(function() {
    'use strict';

    //angular.module('kungfu.job', ['ngFileUpload', 'ngMaterial', 'ui.select', 'ngSanitize'])
    angular.module('kungfu.job', ['ngFileUpload', 'ui.select', 'ngSanitize'])
        //.config(routeConfig);
        //.config(amChartConfig);

    .config(routeConfig)

    // .config(function(baConfigProvider){
    //   var layoutColors = baConfigProvider.colors;
    //   //console.log('===baConfigProvider===>' + JSON.stringify(baConfigProvider));
    //   //console.log('===Morris===>' + JSON.stringify(Morris));
    //   Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
    //   Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
    //   Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
    //   Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    // });

    /** @ngInject */
    function routeConfig($urlRouterProvider, $stateProvider) {

        //console.log('SSSS123===>' + $window.location.href);
        // if ($window.location.href.includes("admin")) {
        //     $window.location.href = 'www.google.com';
        // } else {
        //     $urlRouterProvider.otherwise('/job/job/list');
        // }

        $urlRouterProvider.otherwise('/cust/cust/list');

        $stateProvider
            .state('signin', {
                url: '/signin',
                templateUrl: 'app/kungfu/auth/auth.html',
                controller: 'AuthCtrl as authCtrl'
            })
            .state('cust2', {
                url: '/cust',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: '客戶專區',
                sidebarMeta: {
                    icon: 'ion-person-stalker',
                    order: 305,
                },
            })
            .state('cust2.list', {
                url: '/cust/list',
                sidebarMeta: {
                    order: 301,
                },
                templateUrl: 'app/kungfu/cust/cust.html',
                controller: 'CustCtrl as custCtrl',
                title: '案件資訊',
                views: {
                    '': {
                        templateUrl: 'app/kungfu/cust/cust.html',
                        controller: 'CustCtrl as custCtrl',
                        title: '客戶專區',

                    },
                }
            })
            // .state('cust2.list2', {
            //     url: '/cust/list2',
            //     sidebarMeta: {
            //         order: 302,
            //     },
            //     templateUrl: 'app/kungfu/cust/cust.html',
            //     controller: 'CustCtrl as custCtrl',
            //     title: '獎金統計',
            //     views: {
            //         '': {
            //             templateUrl: 'app/kungfu/cust/cust.html',
            //             controller: 'CustCtrl as custCtrl',
            //             title: '客戶專區',

            //         },
            //     }
            // })
            // .state('cust2.list3', {
            //     url: '/cust/list3',
            //     sidebarMeta: {
            //         order: 303,
            //     },
            //     templateUrl: 'app/kungfu/cust/cust.html',
            //     controller: 'CustCtrl as custCtrl',
            //     title: '歷史案件',
            //     views: {
            //         '': {
            //             templateUrl: 'app/kungfu/cust/cust.html',
            //             controller: 'CustCtrl as custCtrl',
            //             title: '客戶專區',

            //         },
            //     }
            // })
            // .state('cust2.list', {
            //     url: '/cust/list',
            //     sidebarMeta: {
            //         order: 301,
            //     },
            //     templateUrl: 'app/kungfu/cust/cust.html',
            //     controller: 'CustCtrl as custCtrl',
            //     title: '回到首頁',
            //     views: {
            //         '': {
            //             templateUrl: 'app/kungfu/cust/cust.html',
            //             controller: 'CustCtrl as custCtrl',
            //             title: '回到首頁',

            //         },
            //     }
            // })
            // .state('cust2.list', {
            //     url: '/cust/list',
            //     sidebarMeta: {
            //         order: 301,
            //     },
            //     templateUrl: 'app/kungfu/cust/cust.html',
            //     controller: 'CustCtrl as custCtrl',
            //     title: '電子型錄',
            //     views: {
            //         '': {
            //             templateUrl: 'app/kungfu/cust/cust.html',
            //             controller: 'CustCtrl as custCtrl',
            //             title: '電子型錄',

            //         },
            //     }
            // })

        //     .state('job', {
        //         url: '/job',
        //         template: '<ui-view></ui-view>',
        //         abstract: true,
        //         title: '工單',
        //         sidebarMeta: {
        //             icon: 'ion-compose',
        //             order: 105,
        //         },
        //     })
        //     .state('job.list', {
        //         url: '/job/list',
        //         sidebarMeta: {
        //             order: 100,
        //         },
        //         templateUrl: 'app/kungfu/job/job.html',
        //         controller: 'JobCtrl as jobCtrl',
        //         title: '工單排程',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/job/job.html',
        //                 controller: 'JobCtrl as jobCtrl',
        //                 title: 'Job List',

        //             }
        //         }
        //     })
        //     .state('report', {
        //         url: '/report',
        //         template: '<ui-view></ui-view>',
        //         abstract: true,
        //         title: '報表',
        //         sidebarMeta: {
        //             icon: 'fa fa fa-area-chart',
        //             order: 205,
        //         },
        //     })
        //     .state('report.list', {
        //         url: '/report/list/:jobPage',
        //         sidebarMeta: {
        //             order: 201,
        //         },
        //         templateUrl: 'app/kungfu/report/report.html',
        //         controller: 'ReportCtrl as reportCtrl',
        //         title: '工單總表',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/report/report.html',
        //                 controller: 'ReportCtrl as reportCtrl',
        //                 title: 'Report List',

        //             },
        //         }
        //     })
        //     .state('report.arrearCases', {
        //         url: '/report/arrearCases/:arrearPage',
        //         sidebarMeta: {
        //             order: 202,
        //         },
        //         templateUrl: 'app/kungfu/report/arrearCases.html',
        //         controller: 'ReportCtrl as reportCtrl',
        //         title: '催帳報表',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/report/arrearCases.html',
        //                 controller: 'ReportCtrl as reportCtrl',
        //                 title: 'Arrear Cases',

        //             },
        //         }
        //     })
        //     .state('report.sale', {
        //         url: '/custManagment/sale/:sale',
        //         sidebarMeta: {
        //             order: 203,
        //         },
        //         templateUrl: 'app/kungfu/user/sale.html',
        //         controller: 'ChartCtrl as chartCtrl',
        //         title: '業績統計',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/user/sale.html',
        //                 controller: 'ChartCtrl as chartCtrl',
        //                 title: '業績統計',

        //             },
        //         }
        //     })

        //     .state('worker', {
        //         url: '/worker',
        //         template: '<ui-view></ui-view>',
        //         abstract: true,
        //         title: '師傅案件',
        //         sidebarMeta: {
        //             icon: 'ion-person-stalker',
        //             order: 625,
        //         },
        //     })
        //     .state('worker.case', {
        //         url: '/worker/list/:worker',
        //         sidebarMeta: {
        //             order: 621,
        //         },
        //         templateUrl: 'app/kungfu/user/user.html',
        //         controller: 'UserCtrl as userCtrl',
        //         title: '施工案件',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/user/user.html',
        //                 controller: 'UserCtrl as userCtrl',
        //                 title: '施工案件',

        //             },
        //             // 'host-edit@job.list': {
        //             //     templateUrl: 'app/kungfu/job/largeModal.html'
        //             // },
        //         }
        //     })

        //     .state('user', {
        //         url: '/user',
        //         template: '<ui-view></ui-view>',
        //         abstract: true,
        //         title: '使用者管理',
        //         sidebarMeta: {
        //             icon: 'ion-person-stalker',
        //             order: 925,
        //         },
        //     })
        //     .state('user.memeber', {
        //         url: '/user/list/:user',
        //         sidebarMeta: {
        //             order: 921,
        //         },
        //         templateUrl: 'app/kungfu/user/user.html',
        //         controller: 'UserCtrl as userCtrl',
        //         title: '使用者清單',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/user/user.html',
        //                 controller: 'UserCtrl as userCtrl',
        //                 title: '使用者清單',

        //             },
        //             // 'host-edit@job.list': {
        //             //     templateUrl: 'app/kungfu/job/largeModal.html'
        //             // },
        //         }
        //     })

        //     .state('custManagment.company', {
        //         url: '/custManagment/company/:company',
        //         sidebarMeta: {
        //             order: 952,
        //         },
        //         templateUrl: 'app/kungfu/user/company.html',
        //         controller: 'UserCtrl as userCtrl',
        //         title: '公司管理',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/user/company.html',
        //                 controller: 'UserCtrl as userCtrl',
        //                 title: '公司管理',

        //             },
        //             // 'host-edit@job.list': {
        //             //     templateUrl: 'app/kungfu/job/largeModal.html'
        //             // },
        //         }
        //     })
        //     .state('custManagment.bonus', {
        //         url: '/custManagment/bonus/:bonus',
        //         sidebarMeta: {
        //             order: 954,
        //         },
        //         templateUrl: 'app/kungfu/user/bonus.html',
        //         controller: 'UserCtrl as userCtrl',
        //         title: '案件獎金管理',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/user/bonus.html',
        //                 controller: 'UserCtrl as userCtrl',
        //                 title: '案件獎金管理',

        //             },
        //             // 'host-edit@job.list': {
        //             //     templateUrl: 'app/kungfu/job/largeModal.html'
        //             // },
        //         }
        //     })


        // .state('cust2', {
        //         url: '/cust',
        //         template: '<ui-view></ui-view>',
        //         abstract: true,
        //         title: '客戶專區',
        //         sidebarMeta: {
        //             icon: 'ion-person-stalker',
        //             order: 305,
        //         },
        //     })
        //     .state('cust2.list', {
        //         url: '/cust/list',
        //         sidebarMeta: {
        //             order: 301,
        //         },
        //         templateUrl: 'app/kungfu/cust/cust.html',
        //         controller: 'CustCtrl as custCtrl',
        //         title: '主頁',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/cust/cust.html',
        //                 controller: 'CustCtrl as custCtrl',
        //                 title: '客戶專區',

        //             },
        //         }
        //     })
        //     .state('cust2.list2', {
        //         url: '/cust/list2',
        //         sidebarMeta: {
        //             order: 302,
        //         },
        //         templateUrl: 'app/kungfu/cust/cust.html',
        //         controller: 'CustCtrl as custCtrl',
        //         title: '獎金統計',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/cust/cust.html',
        //                 controller: 'CustCtrl as custCtrl',
        //                 title: '客戶專區',

        //             },
        //         }
        //     })
        //     .state('cust2.list3', {
        //         url: '/cust/list3',
        //         sidebarMeta: {
        //             order: 303,
        //         },
        //         templateUrl: 'app/kungfu/cust/cust.html',
        //         controller: 'CustCtrl as custCtrl',
        //         title: '歷史案件',
        //         views: {
        //             '': {
        //                 templateUrl: 'app/kungfu/cust/cust.html',
        //                 controller: 'CustCtrl as custCtrl',
        //                 title: '客戶專區',

        //             },
        //         }
        //     })

      

        ;

    }

   

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      // 'chart.js',
      // 'angular-chartist',
      // 'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components'
  ]);

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

// 'use strict';

// angular.module('BlurAdmin', [
//     'ngAnimate',
//     'ui.bootstrap',
//     'ui.sortable',
//     'ui.router',
//     'ngTouch',
//     'toastr',
//     'smart-table',
//     "xeditable",
//     'ui.slimscroll',
//     'ngJsTree',
//     'angular-progress-button-styles',

//     'BlurAdmin.theme',
//     // 'BlurAdmin.pages',
//     'kungfu.job',

// ]);


(function() {
    'use strict';

    angular.module('BlurAdmin', [
            'ngAnimate',
            'ui.bootstrap',
            'ui.sortable',
            'ui.router',
            'ngTouch',
            'toastr',
            'smart-table',
            "xeditable",
            'ui.slimscroll',
            // 'ngJsTree',
            'angular-progress-button-styles',
            'BlurAdmin.theme',
            // 'BlurAdmin.pages',
            'kungfu.job',
        ])
        .config(HttpProviderConfig)
        .factory('AuthInterceptor', AuthInterceptor);

    //HttpProviderConfig.$inject = ['$httpProvider'];

    function HttpProviderConfig($httpProvider) {
        console.log('$httpProvider-->' + $httpProvider);

        //$httpProvider.interceptors.push('HttpInterceptor');
        $httpProvider.interceptors.push('AuthInterceptor');
        //$httpProvider.interceptors.push('ClusterInterceptor');
        //$httpProvider.interceptors.push('ApplicationInterceptor');

        //initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        //disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
    }

    /**
     * Don't use ui-router $state, it would cause circular dependency.
     * $location.path('/signin') doesn't work.
     */
    function AuthInterceptor($injector, $location, $q, $window) {
        return {
            request: function(config) {
                // add a token header to all AngularJS http requests
                
          
                // $window.localStorage.setItem('token', 'xxxxxxxxxxxxxxxxxxxxxxxx');
                // console.log('token:' + $window.localStorage.getItem('token'));
                // var token = $window.localStorage.getItem('token');
                // if (token) {
                //     config.headers['X-Auth-Token'] = token;
                // }

                return config || $q.when(config);
            },
            responseError: function(rejection) {
                // if unauthorized (status=401), redirect to signin page
                // use $location.url() instead of rejection.config.url(ajax call url) for redirecting only one time 
                if (rejection.status === 401 && $location.url() !== '/signin') {
                    //UserSession.clear();
                    //Notice.alert(rejection.data);
                    $injector.get('$state').go('signin', { url: $location.url() });
                }
                return $q.reject(rejection);
            }
        };
    }

    function HttpInterceptor($q, $cookies) {
        return {
            // request: function(config) {
            //     HttpRequestService.setTimeout(config);
            //     return config || $q.when(config);
            // },
            // responseError: function(rejection) {
            //     var timeout = rejection.config.timeout;
            //     if (timeout && timeout.isGloballyCancelled) {
            //         return $q.defer().promise;
            //     }
            //     return $q.reject(rejection);
            // }
        };
    }

    // /** @ngInject */
    // function routeConfig($stateProvider) {
    //     $stateProvider
    //         .state('root', {
    //             abstract: true,
    //             url: '/111',
    //             views: {
    //                 '': {
    //                     templateUrl: 'app/layout/main.html',
    //                     controller: 'AuthCtrl as authCtrl'
    //                 },
    //             }
    //         })


    // }

})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .service('cityService', CityService)

    function CityService() {

        this.getCountry = function() {
            return country;
        };

        this.getCountryList = function() {
            return countryList;
        };

        this.getDistrict = function(index) {
            return district[index];
        };

        var countryList = [
            { '台北市': '台北市' }, 
            { '基隆市': '基隆市' }, 
            { '新北市': '新北市' },
            { '宜蘭縣': '宜蘭縣' },
            { '新竹市': '新竹市' },
            { '新竹縣': '新竹縣' },
            { '桃園市': '桃園市' },
            { '苗栗縣': '苗栗縣' },
            { '台中市': '台中市' },
            { '彰化縣': '彰化縣' },
            { '南投縣': '南投縣' },
            { '嘉義縣': '嘉義縣' },
            { '雲林縣': '雲林縣' },
            { '台南市': '台南市' },
            { '高雄市': '高雄市' },
            { '屏東縣': '屏東縣' },
            { '台東縣': '台東縣' },
            { '花蓮縣': '花蓮縣' }
        ];

        var country = [
            '台北市', '基隆市', '新北市', '宜蘭縣', '新竹市', '新竹縣', '桃園市', '苗栗縣', '台中市',
            '彰化縣', '南投縣', '嘉義縣', '雲林縣', '台南市', '高雄市', '澎湖縣',
            '屏東縣', '台東縣', '花蓮縣', '金門縣', '連江縣',
            // '南海諸島', '釣魚台列嶼'
        ];

        var district = [
            // 台北市
            [
                ['中正區', '大同區', '中山區', '松山區', '大安區', '萬華區', '信義區', '士林區',
                    '北投區', '內湖區', '南港區', '文山區'
                ],
                //['100', '103', '104', '105', '106', '108', '110', '111', '112', '114', '115', '116']
            ],
            // 基隆市
            [
                ['仁愛區', '信義區', '中正區', '中山區', '安樂區', '暖暖區', '七堵區'],
                //['200', '201', '202', '203', '204', '205', '206']
            ],
            // 新北市
            [
                ['萬里區', '金山區', '板橋區', '汐止區', '深坑區', '石碇區', '瑞芳區', '平溪區',
                    '雙溪區', '貢寮區', '新店區', '坪林區', '烏來區', '永和區', '中和區', '土城區',
                    '三峽鎮', '樹林區', '鶯歌區', '三重區', '新莊區', '泰山區', '林口區', '蘆洲區',
                    '五股區', '八里區', '淡水鎮', '三芝區', '石門區'
                ],
                // ['207', '208', '220', '221', '222', '223', '224', '226', '227', '228',
                //     '231', '232', '233', '234', '235', '236', '237', '238', '239', '241',
                //     '242', '243', '244', '247', '248', '249', '251', '252', '253'
                // ]
            ],
            // 宜蘭縣
            [
                ['宜蘭市', '頭城鎮', '礁溪鄉', '壯圍鄉', '員山鄉', '羅東鎮', '三星鄉', '大同鄉',
                    '五結鄉', '冬山鄉', '蘇澳鎮', '南澳鄉'
                ],
                // ['260', '261', '262', '263', '264', '265', '266', '267', '268', '269',
                //     '270', '272'
                // ]
            ],
            // 新竹市
            [
                ['東區', '北區', '香山區'],
                // ['300', '302', '303', '304', '305', '306', '307', '308', '310', '311',
                //     '312', '313', '314', '315'
                // ]
            ],
            // 新竹縣
            [
                ['竹北市', '湖口鄉', '新豐鄉', '新埔鎮', '關西鎮', '芎林鄉', '寶山鄉',
                    '竹東鎮', '五峰鄉', '橫山鄉', '尖石鄉', '北埔鄉', '峨眉鄉'
                ],
                // ['300', '302', '303', '304', '305', '306', '307', '308', '310', '311',
                //     '312', '313', '314', '315'
                // ]
            ],
            // 桃園市
            [
                ['中壢區', '平鎮區', '龍潭區', '楊梅區', '新屋區', '觀音區', '桃園區', '龜山區',
                    '八德區', '大溪區', '復興區', '大園區', '蘆竹區'
                ],
                // ['320', '324', '325', '326', '327', '328', '330', '333', '334', '335',
                //     '336', '337', '338'
                // ]
            ],
            // 苗栗縣
            [
                ['竹南鎮', '頭份鎮', '三灣鄉', '南庄鄉', '獅潭鄉', '後龍鎮', '通霄鎮', '苑裡鎮',
                    '苗栗市', '造橋鄉', '頭屋鄉', '公館鄉', '大湖鄉', '泰安鄉',
                    '銅鑼鄉', '三義鄉', '西湖鄉', '卓蘭鎮'
                ],
                // ['350', '351', '352', '353', '354', '356', '357', '358', '360', '361',
                //     '362', '363', '364', '365', '366', '367', '368', '369'
                // ]
            ],
            // 台中市
            [
                ['中區', '東區', '南區', '西區', '北區', '北屯區', '西屯區', '南屯區', '太平區',
                    '大里區', '霧峰區', '烏日區', '豐原區', '后里區', '石岡區', '東勢區', '和平區',
                    '新社區', '潭子區', '大雅區', '神岡區', '大肚區', '沙鹿區', '龍井區', '梧棲區',
                    '清水區', '大甲區', '外埔區', '大安區'
                ],
                // ['400', '401', '402', '403', '404', '406', '407', '408', '411', '412',
                //     '413', '414', '420', '421', '422', '423', '424', '426', '427', '428',
                //     '429', '432', '433', '434', '435', '436', '437', '438', '439'
                // ]
            ],
            // 彰化縣
            [
                ['彰化市', '芬園鄉', '花壇鄉', '秀水鄉', '鹿港鎮', '福興鄉', '線西鄉', '和美鎮',
                    '伸港鄉', '員林鎮', '社頭鄉', '永靖鄉', '埔心鄉', '溪湖鎮', '大村鄉', '埔鹽鄉',
                    '田中鎮', '北斗鎮', '田尾鄉', '埤頭鄉', '溪州鄉', '竹塘鄉', '二林鎮', '大城鄉',
                    '芳苑鄉', '二水鄉'
                ],
                // ['500', '502', '503', '504', '505', '506', '507', '508', '509', '510',
                //     '511', '512', '513', '514', '515', '516', '520', '521', '522', '523',
                //     '524', '525', '526', '527', '528', '530'
                // ]
            ],
            // 南投縣
            [
                ['南投市', '中寮鄉', '草屯鎮', '國姓鄉', '埔里鎮', '仁愛鄉', '名間鄉', '集集鎮',
                    '水里鄉', '魚池鄉', '信義鄉', '竹山鎮', '鹿谷鄉'
                ],
                // ['540', '541', '542', '544', '545', '546', '551', '552', '553', '555',
                //     '556', '557', '558'
                // ]
            ],
            // 嘉義縣市
            [
                ['嘉義市', '番路鄉', '梅山鄉', '竹崎鄉', '阿里山', '中埔鄉', '大埔鄉', '水上鄉',
                    '鹿草鄉', '太保市', '朴子市', '東石鄉', '六腳鄉', '新港鄉', '民雄鄉', '大林鎮',
                    '溪口鄉', '義竹鄉', '布袋鎮'
                ],
                // ['600', '602', '603', '604', '605', '606', '607', '608', '611', '612',
                //     '613', '614', '615', '616', '621', '622', '623', '624', '625'
                // ]
            ],
            // 雲林縣
            [
                ['斗南鎮', '大埤鄉', '虎尾鎮', '土庫鎮', '褒忠鄉', '東勢鄉', '台西鄉', '崙背鄉',
                    '麥寮鄉', '斗六市', '林內鄉', '古坑鄉', '莿桐鄉', '西螺鎮', '二崙鄉', '北港鎮',
                    '水林鄉', '口湖鄉', '四湖鄉', '元長鄉'
                ],
                // ['630', '631', '632', '633', '634', '635', '636', '637', '638', '640', '643',
                //     '646', '647', '648', '649', '651', '652', '653', '654', '655'
                // ]
            ],
            // 台南市
            [
                ['中西區', '東區', '南區', '北區', '安平區', '安南區', '永康區', '歸仁區', '新化區',
                    '左鎮區', '玉井區', '楠西區', '南化區', '仁德區', '關廟區', '龍崎區', '官田區',
                    '麻豆區', '佳里區', '西港區', '七股區', '將軍區', '學甲區', '北門區', '新營區',
                    '後壁區', '白河區', '東山區', '六甲區', '下營區', '柳營區', '鹽水區', '善化區',
                    '大內區', '山上區', '新市區', '安定區'
                ],
                // ['700', '701', '702', '704', '708', '709', '710', '711', '712', '713', '714',
                //     '715', '716', '717', '718', '719', '720', '721', '722', '723', '724', '725',
                //     '726', '727', '730', '731', '732', '733', '734', '735', '736', '737', '741',
                //     '742', '743', '744', '745'
                // ]
            ],
            // 高雄市
            [
                ['新興區', '前金區', '苓雅區', '鹽埕區', '鼓山區', '旗津區', '前鎮區', '三民區',
                    '楠梓區', '小港區', '左營區', '仁武區', '大社區', '岡山區', '路竹區', '阿蓮區',
                    '田寮區', '燕巢區', '橋頭區', '梓官區', '彌陀區', '永安區', '湖內區', '鳳山市',
                    '大寮區', '林園區', '鳥松區', '大樹區', '旗山區', '美濃區', '六龜區', '內門區',
                    '杉林區', '甲仙區', '桃源區', '那瑪夏區', '茂林區', '茄萣區'
                ],
                // ['800', '801', '802', '803', '804', '805', '806', '807', '811', '812', '813',
                //     '814', '815', '820', '821', '822', '823', '824', '825', '826', '827', '828',
                //     '829', '830', '831', '832', '833', '840', '842', '843', '844', '845', '846',
                //     '847', '848', '849', '851', '852'
                // ]
            ],
            // 澎湖縣
            [
                ['馬公市', '西嶼鄉', '望安鄉', '七美鄉', '白沙鄉', '湖西鄉'],
                // ['880', '881', '882', '883', '884', '885']
            ],
            // 屏東縣
            [
                ['屏東市', '三地門', '霧台鄉', '瑪家鄉', '九如鄉', '里港鄉', '高樹鄉', '鹽埔鄉',
                    '長治鄉', '麟洛鄉', '竹田鄉', '內埔鄉', '萬丹鄉', '潮州鎮', '泰武鄉', '來義鄉',
                    '萬巒鄉', '崁頂鄉', '新埤鄉', '南州鄉', '林邊鄉', '東港鎮', '琉球鄉', '佳冬鄉',
                    '新園鄉', '枋寮鄉', '枋山鄉', '春日鄉', '獅子鄉', '車城鄉', '牡丹鄉', '恆春鎮',
                    '滿州鄉'
                ],
                // ['900', '901', '902', '903', '904', '905', '906', '907', '908', '909', '911',
                //     '912', '913', '920', '921', '922', '923', '924', '925', '926', '927', '928',
                //     '929', '931', '932', '940', '941', '942', '943', '944', '945', '946', '947'
                // ]
            ],
            // 台東縣
            [
                ['台東市', '綠島鄉', '蘭嶼鄉', '延平鄉', '卑南鄉', '鹿野鄉', '關山鎮', '海端鄉',
                    '池上鄉', '東河鄉', '成功鎮', '長濱鄉', '太麻里', '金峰鄉', '大武鄉', '達仁鄉'
                ],
                // ['950', '951', '952', '953', '954', '955', '956', '957', '958', '959', '961',
                //     '962', '963', '964', '965', '966'
                // ]
            ],
            // 花蓮縣
            [
                ['花蓮市', '新城鄉', '秀林鄉', '吉安鄉', '壽豐鄉', '鳳林鎮', '光復鄉', '豐濱鄉',
                    '瑞穗鄉', '萬榮鄉', '玉里鎮', '卓溪鄉', '富里鄉'
                ],
                // ['970', '971', '972', '973', '974', '975', '976', '977', '978', '979', '981',
                //     '982', '983'
                // ]
            ],
            // 金門縣
            [
                ['金沙鎮', '金湖鎮', '金寧鄉', '金城鎮', '烈嶼鄉', '烏坵鄉'],
                // ['890', '891', '892', '893', '894', '896']
            ],
            // 連江縣
            [
                ['南竿鄉', '北竿鄉', '莒光鄉', '東引鄉'],
                // ['209', '210', '211', '212']
            ],
            // 南海諸島
            [
                ['東沙', '南沙'],
                // ['817', '819']
            ],
            // 釣魚台列嶼
            [
                ['釣魚台列嶼'],
                // ['290']
            ]
        ];

        return '';
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper) {
    baConfigProvider.changeTheme({blur: false});
    
    baConfigProvider.changeColors({
     default: 'rgba(#000000, 0.2)',
     defaultText: '#ffffff',
     dashboard: {
       white: '#ffffff',
     },
    });
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      //***DIS AMCHART***
      //preloader.loadAmCharts(),
      //$timeout(3000)
      $timeout(1000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 1000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('AuthCtrl', AuthCtrl)


    /** @ngInject */
    function AuthCtrl($rootScope, $scope, $window, authService) {

        console.log('===============WELCOME AuthCtrl==========================');
        //Base Setting
        var vm = this;
        //vm.$rootScope = $rootScope;
        vm.$scope = $scope;
        vm.AuthService = authService;
        vm.signin = {};
        //vm.$rootScope.isLoginPage = true;
        //vm.$rootScope.isMainPage = false;

        if ($window.location.href.includes("admin")) {
            $window.location.href = 'http://www.kobestone.com:8088';
        } else {
            //$urlRouterProvider.otherwise('/job/job/list');
        }

        $scope.nosignin = function() {
            $rootScope.isLogin = true;
        }

        $scope.signin = function() {
            var type = "cust";
            console.log('login in account: ' + $scope.xaccount);
            vm.signin.account = vm.$scope.xaccount;
            vm.signin.password = vm.$scope.xpasswd;
            vm.AuthService.signin(vm.signin, type).then(
                function(data) {
                    $rootScope.isLogin = true;
                    $rootScope.token = data.data.id;
                    $window.localStorage.setItem('token', data.data.id);
                    $window.localStorage.setItem('user', data.data.account);
                    $window.localStorage.setItem('userId', data.data.userId);
                    $window.localStorage.setItem('userType', data.data.userType);
                    // 有時登入後baSidebarCtrl無法觸動, 因此強制reload
                    $window.location.reload();
                },
                function() {
                    alert('帳號或密碼有誤!');
                    console.error('Sign in failed!');
                }
            );
        };

        $scope.logout = function() {
            var account = $window.localStorage.getItem('user');
            vm.AuthService.logout(account).then(
                function(data) {
                    $rootScope.isLogin = false;
                    $window.localStorage.setItem('token', null);
                    $window.localStorage.setItem('user', null);
                    $window.localStorage.setItem('userId', null);
                    $window.localStorage.setItem('userType', null);
                    $window.localStorage.clear();
                },
                function() {
                    console.error('Logout failed!');
                }
            );
        };

        $scope.checkToken = function(token) {
            console.log('token: ' + token);
            vm.AuthService.checkToken(token).then(
                function(data) {
                    console.log('Token is good: ' + data.data);
                    if (data.data) {
                        $rootScope.isLogin = true;
                        $rootScope.token = token;
                        $window.localStorage.setItem('token', angular.toJson(token));
                    } else {
                        $rootScope.isLogin = false;
                        $rootScope.token = null;
                        $window.localStorage.setItem('token', null);
                    }
                },
                function() {
                    console.error('Token in failed!');
                    $rootScope.isLogin = false;
                    $rootScope.token = null;
                    $window.localStorage.setItem('token', null);
                }
            );


        };

        //$rootScope.isLogin = true
        if ($window.localStorage.getItem('token') !== undefined && $window.localStorage.getItem('token') !== null) {
            var token = $window.localStorage.getItem('token').replace(/"/g, "");
            if (token !== 'null' && token !== '') {
                vm.$scope.checkToken(token);
            }
        }


    }



})();

(function() {

    'use strict';

    angular.module('kungfu.job')
        .service('authService', AuthService);

    AuthService.$inject = ['$http'];

    function AuthService($http) {

        this.signin = function(signin, type) {
            return $http.post('/api/signin/' + type, signin);
        };

        this.checkToken = function(token) {
            return $http.get('/api/check-auth/' + token);
        };

        this.logout = function(account) {
            return $http.delete('/api/logout/' + account);
        };

    }


})();


(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('ChartCtrl', ChartCtrl)

    // //var $injector = angular.injector(['kungfu.job']);


    // console.log('CommonCtrl=====>' + CommonCtrl);

    // UserCtrl.prototype = Object.create(CommonCtrl.prototype);

    /** @ngInject */
    function ChartCtrl($scope, $uibModal, $window, $stateParams, $document,
        $timeout, userService, itemService, cityService, $http, baConfig, $element, layoutPaths) {

        console.log('===============WELCOME UserCtrl==========================');
        //Extend CommonCtrl
        //var CommonCtrl = angular.extend(this, $controller('CommonCtrl', { $scope: $scope }));


        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$window = $window;
        vm.$uibModal = $uibModal;
        vm.UserService = userService;
        vm.ItemService = itemService;
        vm.CityService = cityService;
        vm.reportJobs = [];
        //vm.JobService = jobService;

        query();

        var layoutColors = baConfig.colors;
        console.log('11 baConfig.colors====>' + JSON.stringify(baConfig));
        console.log('22 baConfig.colors====>' + JSON.stringify(baConfig.colors));

        var id = $element[0].getAttribute('id');
        var barChart = AmCharts.makeChart(id, {
            type: 'serial',
            theme: 'light',
            //color: 'black',
            dataProvider: [],
            valueAxes: [{
                axisAlpha: 0,
                position: 'left',
                title: 'Visitors from country',
                gridAlpha: 0.5,
                gridColor: layoutColors.border,
                //gridColor: 'black',
                //color: 'black',
                //titleColor: 'black'
            }],
            startDuration: 1,
            graphs: [{
                balloonText: '<b>[[category]]: [[value]]</b>',
                fillColorsField: 'color',
                fillAlphas: 0.7,
                lineAlpha: 0.2,
                type: 'column',
                valueField: 'number'
            }],
            chartCursor: {
                categoryBalloonEnabled: false,
                cursorAlpha: 0,
                zoomable: false
            },
            categoryField: 'yearMonth',
            categoryAxis: {
                gridPosition: 'start',
                labelRotation: 45,
                gridAlpha: 0.5,
                gridColor: layoutColors.border,
            },
            export: {
                enabled: true
            },
            creditsPosition: 'top-right',
            pathToImages: layoutPaths.images.amChart
        });

        function query() {
            console.log('55555555555599999999999');
            var vm = this;
            var reportStartTime = new Date().getTime();
            var reportEndTime = new Date().getTime();
            var params = {};
            params.start = reportStartTime;
            params.end = reportEndTime;

            getCaseCust(params).then(
                function(data) {
                    //vm.caseCusts = data.data;
                    barChart.dataProvider = data.data;
                    //console.log('fff: ' + JSON.stringify(data.data));
                    barChart.validateData();
                },
                function() {
                    console.error('Get reports failed!');
                }
            );
        };

        function getCaseCust(params) {
            return $http.get('/api/case-cust', {
                params: params
            });
        };
    }

})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('DesignerBarChartCtrl', DesignerBarChartCtrl)


    /** @ngInject */
    function DesignerBarChartCtrl($scope, $window, $http, baConfig, $element, layoutPaths) {

        console.log('===============WELCOME PieChartCtrl==========================');

        //Base Setting
        var vm = this;
        var reportJobs = [];
        vm.$scope = $scope;
        vm.$window = $window;
        vm.baConfig = baConfig;

        query();

        var layoutColors = baConfig.colors;
        var id = $element[0].getAttribute('id');
        var chart = AmCharts.makeChart(id, {
            "type": "serial",
            "theme": "light",
            "color": 'black',
            "dataDateFormat": "YYYY-MM",
            "precision": 0,
            "valueAxes": [{
                color: 'black',
                axisColor: 'black',
                gridColor: 'black',
                "id": "v1",
                "title": "設計師成長表",
                "position": "left",
                "autoGridCount": false,
                "labelFunction": function(value) {
                    return Math.round(value) + "人";
                }
            }],
            "graphs": [{
                "id": "g3",
                "color": 'black',
                "valueAxis": "v1",
                "lineColor": '#424242',
                "fillColors": '#E6E6E6',
                "fillAlphas": 0.8,
                "lineAlpha": 0.8,
                "type": "column",
                "title": "年度設計師人數",
                "valueField": "yearNumber",
                "clustered": false,
                "columnWidth": 10,
                "lineColorField": 'black',
                "legendValueText": "[[value]]人",
                "balloonText": "[[year]]年<br/><b style='font-size: 130%'>[[value]]人</b>"
            }, {
                "id": "g4",
                "valueAxis": "v1",
                "color": 'black',
                "lineColor": 'white',
                "fillColors": '#585858',
                "fillAlphas": 0.9,
                "lineAlpha": 0.9,
                "type": "column",
                "title": "當月設計師人數",
                "valueField": "monthNumber",
                "clustered": false,
                "columnWidth": 12,
                "legendValueText": "[[value]]人",
                "balloonText": "[[yearMonth]]月<br/><b style='font-size: 130%'>[[value]]人</b>"
            }],
            // "chartScrollbar": {
            //     "graph": "g1",
            //     "oppositeAxis": false,
            //     "offset": 30,
            //     gridAlpha: 0,
            //     color: layoutColors.defaultText,
            //     scrollbarHeight: 50,
            //     backgroundAlpha: 0,
            //     selectedBackgroundAlpha: 0.05,
            //     selectedBackgroundColor: layoutColors.defaultText,
            //     graphFillAlpha: 0,
            //     autoGridCount: true,
            //     selectedGraphFillAlpha: 0,
            //     graphLineAlpha: 0.2,
            //     selectedGraphLineColor: layoutColors.defaultText,
            //     selectedGraphLineAlpha: 1
            // },
            "chartCursor": {
                "pan": true,
                "cursorColor": layoutColors.danger,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 0,
                "valueLineAlpha": 0.2
            },
            "categoryField": "yearMonth",
            "categoryAxis": {
                "axisColor": "black",
                "color": "black",
                "gridColor": "black",
                "parseDates": true,
                "dashLength": 1,
                "minorGridEnabled": true
            },
            "legend": {
                "useGraphSettings": true,
                "position": "top",
                "color": 'black'
            },
            "balloon": {
                "borderThickness": 1,
                "shadowAlpha": 0
            },
            "export": {
                "enabled": true
            },
            "dataProvider": [],
            pathToImages: layoutPaths.images.amChart
        });

        function query(reportJobs) {
            var reportStartTime = new Date().getTime();
            var reportEndTime = new Date().getTime();
            var params = {};
            params.start = reportStartTime;
            params.end = reportEndTime;

            getDatas(params).then(
                function(data) {
                    chart.dataProvider = data.data;
                    //console.log('mix-designer: ' + JSON.stringify(data.data));
                    chart.validateData();
                },
                function() {
                    console.error('Get reports failed!');
                }
            );


        };

        function getDatas(params) {
            return $http.get('/api/mix-designer', {
                params: params
            });
        };



    }

})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('GanttCtrl', GanttCtrl)

    /** @ngInject */
    function GanttCtrl($scope, $uibModal, $window, $stateParams, $document,
        $timeout, $http, baConfig, $element, layoutPaths) {

        console.log('===============WELCOME GanttCtrl==========================');

        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$window = $window;
        vm.$uibModal = $uibModal;
        vm.reportJobs = [];

        //vm.$scope.yyy = '123';

        query(vm.$scope);

        // granttChartH500
        // $scope.selectCust = function(cust) {

        // }





        $scope.queryChart = function() {
            query(vm.$scope);
            //vm.$scope.isActive250 = true;
        }

        function query($scope) {
            console.log(1111111);

            var layoutColors = baConfig.colors;
            //var id = $element[0].getAttribute('id');
            var granttChart = AmCharts.makeChart("granttChart", {
                "type": "gantt",
                "theme": "light",
                "marginRight": 70,
                "period": "DD",
                "dataDateFormat": "YYYY-MM-DD",
                "columnWidth": 1,
                "valueAxis": {
                    "type": "date",
                    "dateFormats": [{ "period": "MM", "format": "MM" }]
                },
                "autoResize": true,
                "brightnessStep": 7,
                "graph": {
                    "fillAlphas": 1,
                    "lineAlpha": 1,
                    "lineColor": "#fff",
                    //"fillAlphas": 0.85,
                    "labelText": "[[task]]",
                    "labelPosition": "middle",
                    "color": "#fff",
                    "balloonText": "<b>[[task]]件</b><br />[[open]]",
                    "dateFormat": "YYYY-MM"
                },
                "rotate": true,
                "categoryField": "name",
                "segmentsField": "caseCustSummarys",
                "colorField": "color",
                "startDateField": "start",
                "endDateField": "end",
                "dataProvider": [],
                "valueScrollbar": {
                    "autoGridCount": true
                },
                "chartCursor": {
                    "cursorColor": "#55bb76",
                    "valueBalloonsEnabled": false,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.5,
                    "valueLineBalloonEnabled": true,
                    "valueLineEnabled": true,
                    "zoomable": false,
                    "valueZoomable": true
                },
                "export": {
                    "enabled": true
                }
            });


            // granttChart.addListener('rendered', zoomChart);
            // if (granttChart.zoomChart) {
            //     granttChart.zoomChart();
            // }

            // function zoomChart() {
            //     granttChart.zoomToIndexes(Math.round(granttChart.dataProvider.length * 0.4), Math.round(granttChart.dataProvider.length * 0.55));
            // }

            //var reportStartTime = new Date().getTime();
            //var reportEndTime = new Date().getTime();
            var params = {};
            //params.start = reportStartTime;
            //params.end = reportEndTime;
            params.company = $scope.qCompany;
            params.line = $scope.qLine;
            params.phone = $scope.qPhone;
            //params.phone = '0988';
            params.custName = $scope.qCustName;

            //console.log('ttt==>' + $scope.yyy);

            getCaseCust(params).then(
                function(data) {
                    var dataSize = data.data.length;
                    granttChart.dataProvider = data.data;
                    console.log('grantt data: ' + JSON.stringify(data.data));
                    console.log('grantt size: ' + data.data.length);
                    granttChart.validateData();


                    //$scope.isActive500 = true;

                    if (parseInt(dataSize) <= 10) {
                        //$scope.isActive250 = true;
                        $scope.isActive500 = true;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = false;
                    } else if (parseInt(dataSize) > 10 && parseInt(dataSize) <= 32) {
                        //$scope.isActive250 = false;
                        $scope.isActive500 = false;
                        $scope.isActive1000 = true;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = false;
                    } else if (parseInt(dataSize) > 32 && parseInt(dataSize) <= 45) {
                        //$scope.isActive250 = false;
                        $scope.isActive500 = false;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = true;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = false;
                    } else if (parseInt(dataSize) > 45 && parseInt(dataSize) <= 60) {
                        $scope.isActive500 = false;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = true;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = false;
                    } else if (parseInt(dataSize) > 60 && parseInt(dataSize) <= 75) {
                        $scope.isActive500 = false;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = true;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = false;
                    } else if (parseInt(dataSize) > 75 && parseInt(dataSize) <= 100) {
                        $scope.isActive500 = false;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = true;
                    } else {
                        $scope.isActive500 = false;
                        $scope.isActive1000 = false;
                        $scope.isActive1500 = false;
                        $scope.isActive2000 = false;
                        $scope.isActive2500 = false;
                        $scope.isActive3000 = false;
                        $scope.isActive4000 = true;
                    }

                    //console.log('$scope.isActive250: ' + $scope.isActive250);

                    //var _class = $element[0].getAttribute('class').classList.add('granttChartH500');;

                },
                function() {
                    console.error('Get reports failed!');
                }
            );
        };

        function getCaseCust(params) {
            return $http.get('/api/cust-case-gantt', {
                params: params
            });
        };
    }

})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('PieChartCtrl', PieChartCtrl)

    // //var $injector = angular.injector(['kungfu.job']);


    // console.log('CommonCtrl=====>' + CommonCtrl);

    // UserCtrl.prototype = Object.create(CommonCtrl.prototype);

    /** @ngInject */
    function PieChartCtrl($scope, $window, $http, baConfig, $element, layoutPaths) {

        console.log('===============WELCOME PieChartCtrl==========================');

        //Base Setting
        var vm = this;
        var reportJobs = [];
        vm.$scope = $scope;
        vm.$window = $window;
        vm.baConfig = baConfig;

        query();

        var layoutColors = baConfig.colors;
        var id = $element[0].getAttribute('id');
        var chart = AmCharts.makeChart(id, {
            "type": "serial",
            "theme": "light",
            "color": 'black',
            "dataDateFormat": "YYYY-MM",
            "precision": 0,
            "valueAxes": [{
                color: 'black',
                axisColor: 'black',
                gridColor: 'black',
                "id": "v1",
                "title": "案件成長表",
                "position": "left",
                "autoGridCount": false,
                "labelFunction": function(value) {
                    return Math.round(value) + "件";
                }
            }],
            "graphs": [{
                "id": "g3",
                "color": 'black',
                "valueAxis": "v1",
                "lineColor": '#D7DF01',
                "fillColors": '#F5F6CE',
                "fillAlphas": 0.8,
                "lineAlpha": 0.8,
                "type": "column",
                "title": "年度案件量",
                "valueField": "yearNumber",
                "clustered": false,
                "columnWidth": 15,
                "lineColorField": 'red',
                "legendValueText": "[[value]]件",
                "balloonText": "[[year]]年<br/><b style='font-size: 130%'>[[value]]件</b>"
            }, {
                "id": "g4",
                "valueAxis": "v1",
                "color": 'black',
                "lineColor": 'white',
                "fillColors": '#FF0040',
                "fillAlphas": 0.9,
                "lineAlpha": 0.9,
                "type": "column",
                "title": "當月案件量",
                "valueField": "monthNumber",
                "clustered": false,
                "columnWidth": 20,
                "legendValueText": "[[value]]件",
                "balloonText": "[[yearMonth]]月<br/><b style='font-size: 130%'>[[value]]件</b>"
            }],
            // "chartScrollbar": {
            //     "graph": "g1",
            //     "oppositeAxis": false,
            //     "offset": 30,
            //     gridAlpha: 0,
            //     color: layoutColors.defaultText,
            //     scrollbarHeight: 50,
            //     backgroundAlpha: 0,
            //     selectedBackgroundAlpha: 0.05,
            //     selectedBackgroundColor: layoutColors.defaultText,
            //     graphFillAlpha: 0,
            //     autoGridCount: true,
            //     selectedGraphFillAlpha: 0,
            //     graphLineAlpha: 0.2,
            //     selectedGraphLineColor: layoutColors.defaultText,
            //     selectedGraphLineAlpha: 1
            // },
            "chartCursor": {
                "pan": true,
                "cursorColor": layoutColors.danger,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 0,
                "valueLineAlpha": 0.2
            },
            "categoryField": "yearMonth",
            "categoryAxis": {
                "axisColor": "black",
                "color": "black",
                "gridColor": "black",
                "parseDates": true,
                "dashLength": 1,
                "minorGridEnabled": true
            },
            "legend": {
                "useGraphSettings": true,
                "position": "top",
                "color": 'black'
            },
            "balloon": {
                "borderThickness": 1,
                "shadowAlpha": 0
            },
            "export": {
                "enabled": true
            },
            "dataProvider": [],
            pathToImages: layoutPaths.images.amChart
        });
        // -----------------MIX----------------

        // var layoutColors = vm.baConfig.colors;
        // console.log('KKK==>' + layoutColors);
        // vm.$scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];

        // vm.$scope.barData = [
        //     { y: "2006", a: 100, b: 90 },
        //     { y: "2007", a: 75, b: 65 },
        //     { y: "2008", a: 50, b: 40 },
        //     { y: "2009", a: 75, b: 65 },
        //     { y: "2010", a: 50, b: 40 },
        //     { y: "2011", a: 75, b: 65 },
        //     { y: "2012", a: 100, b: 90 }
        // ];
        // vm.$scope.donutData = [
        //     { label: "Download Sales", value: 12 },
        //     { label: "In-Store Sales", value: 30 },
        //     { label: "Mail-Order Sales", value: 20 }
        // ];

        // angular.element(vm.$window).bind('resize', function() {
        //     //$window.Morris.Grid.prototype.redraw();
        // });


        // =========================================
        // //vm.JobService = jobService;

        // //query(reportJobs);

        // var layoutColors = baConfig.colors;
        // //console.log('11 baConfig.colors====>' + JSON.stringify(baConfig));
        // //console.log('22 baConfig.colors====>' + JSON.stringify(baConfig.colors));

        // var id = $element[0].getAttribute('id');


        // // ==================PIE CHART=====================
        // var pieChart = AmCharts.makeChart(id, {
        //     type: 'pie',
        //     startDuration: 0,
        //     //theme: 'light',
        //     addClassNames: true,
        //     //color: layoutColors.defaultText,
        //     //labelTickColor: layoutColors.borderDark,
        //     color: 'black',
        //     labelTickColor: 'black',
        //     legend: {
        //         position: 'right',
        //         marginRight: 100,
        //         autoMargins: false,
        //     },
        //     innerRadius: '40%',
        //     defs: {
        //         filter: [{
        //             id: 'shadow',
        //             width: '200%',
        //             height: '200%',
        //             feOffset: {
        //                 result: 'offOut',
        //                 in : 'SourceAlpha',
        //                 dx: 0,
        //                 dy: 0
        //             },
        //             feGaussianBlur: {
        //                 result: 'blurOut',
        //                 in : 'offOut',
        //                 stdDeviation: 5
        //             },
        //             feBlend: { in : 'SourceGraphic',
        //                 in2: 'blurOut',
        //                 mode: 'normal'
        //             }
        //         }]
        //     },

        //     dataProvider: reportJobs,
        //     valueField: 'number',
        //     titleField: 'region',
        //     export: {
        //         enabled: true
        //     },
        //     creditsPosition: 'bottom-left',

        //     autoMargins: false,
        //     marginTop: 10,
        //     alpha: 0.8,
        //     marginBottom: 0,
        //     marginLeft: 0,
        //     marginRight: 0,
        //     pullOutRadius: 0,
        //     pathToImages: layoutPaths.images.amChart,
        //     //labelColorField: 'black',
        //     responsive: {
        //         enabled: true,
        //         rules: [
        //             // at 900px wide, we hide legend
        //             {
        //                 maxWidth: 900,
        //                 overrides: {
        //                     legend: {
        //                         enabled: false
        //                     }
        //                 }
        //             },

        //             // at 200 px we hide value axis labels altogether
        //             {
        //                 maxWidth: 200,
        //                 overrides: {
        //                     valueAxes: {
        //                         labelsEnabled: false
        //                     },
        //                     marginTop: 30,
        //                     marginBottom: 30,
        //                     marginLeft: 30,
        //                     marginRight: 30
        //                 }
        //             }
        //         ]
        //     }
        // });

        // pieChart.addListener('init', handleInit);

        // pieChart.addListener('rollOverSlice', function(e) {
        //     handleRollOver(e);
        // });

        // function handleInit() {
        //     pieChart.legend.addListener('rollOverItem', handleRollOver);
        // }

        // function handleRollOver(e) {
        //     var wedge = e.dataItem.wedge.node;
        //     wedge.parentNode.appendChild(wedge);
        // }

        // $scope.pullJobStatus = function() {
        //     var vm = this;
        //     checkJobStatus(vm.jobCtrl.workJobs);
        // };

        function query(reportJobs) {
            //var vm = this;
            var reportStartTime = new Date().getTime();
            var reportEndTime = new Date().getTime();
            var params = {};
            params.start = reportStartTime;
            params.end = reportEndTime;

            getCaseRegion(params).then(
                function(data) {
                    chart.dataProvider = data.data;
                    //console.log('data.data: ' + JSON.stringify(data.data));
                    chart.validateData();
                },
                function() {
                    console.error('Get reports failed!');
                }
            );


        };

        function getCaseRegion(params) {
            return $http.get('/api/mix-case-cust', {
                params: params
            });
        };



    }

})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .factory('CommonCtrl', CommonCtrl)

    /** @ngInject */
    function CommonCtrl($scope, $window, $stateParams, $uibModalStack, Upload) {

        console.log('===============WELCOME CommonCtrl==========================');
        //Base Setting
        var vm = this;
        vm.$scope = $scope;

        var CommonCtrlObj = function($scope, Resource, resourceName) {
            var vm = this;
            vm.$scope = $scope;
            vm.Resource = Resource;
            vm.resourceName = resourceName;
            vm[vm.resourceName];
            //vm.qryParams = {};
            //vm.delParams = {};
            //vm.pagingTable;
        };

        CommonCtrlObj.prototype.uploadPic = function() {
            var files = vm.Resource.file;
            if (files && files.length) {

                var jobId = vm.Resource.oId;
                if (jobId === '' || jobId === undefined) {
                    jobId = vm.$scope.tmpImgPath;
                    vm.Resource.tmpImgPath = vm.$scope.tmpImgPath;
                }

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    Upload.upload({
                        url: '/api/job/' + jobId + '/upload-file',
                        //data: {file: file, 'username': $scope.username},
                        method: 'PUT',
                        data: { file: file },
                        file: file,
                    }).then(function(resp) {
                        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data.uploadfile);
                        vm.Resource.jobImages.push(resp.data.uploadfile);
                        //$rootScope.jImgs.push(resp.data.uploadfile);
                    }, function(resp) {
                        console.log('Error status: ' + resp.status);
                    }, function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
                // or send them all together for HTML5 browsers:
                //Upload.upload({..., data: { file: files }, ... })...;    

            }
        };

        // for multiple files:
        $scope.uploadPic = function() {

            var files = vm.$scope.fmCust.file;
            if (files && files.length) {

                var jobId = vm.$scope.fmCust.oId;
                if (jobId === '' || jobId === undefined) {
                    jobId = vm.$scope.tmpImgPath;
                    vm.$scope.fmCust.tmpImgPath = vm.$scope.tmpImgPath;
                }

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    Upload.upload({
                        url: '/api/job/' + jobId + '/upload-file',
                        //data: {file: file, 'username': $scope.username},
                        method: 'PUT',
                        data: { file: file },
                        file: file,
                    }).then(function(resp) {
                        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data.uploadfile);
                        vm.$scope.fmCust.jobImages.push(resp.data.uploadfile);
                        //$rootScope.jImgs.push(resp.data.uploadfile);
                    }, function(resp) {
                        console.log('Error status: ' + resp.status);
                    }, function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
                // or send them all together for HTML5 browsers:
                //Upload.upload({..., data: { file: files }, ... })...;    

            }
        }

    }


})();




(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/blurFeed.html'
    };
  }

  /** @ngInject */
  function promoteDesigner() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/promoteDesigner.html'
    };
  }

  function promoteCust() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/promoteCust.html'
    };
  }

  function caseList() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/caseList.html'
    };
  }

})();



(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('bonusPieChart', bonusPieChart);

  /** @ngInject */
  function bonusPieChart() {
    return {
      restrict: 'E',
      controller: 'BonusPieChartCtrl',
      templateUrl: 'app/kungfu/cust/bonusPieChart.html'
    };
  }

})();
(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('BonusPieChartCtrl', BonusPieChartCtrl);

    /** @ngInject */
    function BonusPieChartCtrl($scope, $window, $timeout, $http, baConfig, baUtil) {

        var custId = $window.localStorage.getItem('userId');
        var custType = $window.localStorage.getItem('userType');
        console.log('current custId: ' + custId);
        console.log('current custType: ' + custType);
        $scope.charts = [];
        if (custType !== 'CTH') {
            query(custType, custId);
        }


        function loadPieCharts() {
            $('.chart').easyPieChart({
                //barColor: chart.attr('rel'),
                trackColor: 'rgba(0,0,0,0)',
                size: 78,
                scaleLength: 0,
                animation: 2000,
                lineWidth: 9,
                lineCap: 'round',
                onStep: function(value) {
                    $(this.el).find('span').text(Math.round(value));
                },
                onStop: function(value, to) {
                    $(this.el).find('span').text(Math.round(to));
                }
            });
        }

        $timeout(function() {
            loadPieCharts();
            //updatePieCharts();
        }, 1000);

        // $scope.charts = [{
        //     color: 'red',
        //     description: '已達獎金累計',
        //     description2: '123',
        //     stats: '3/5',
        //     icon: 'shopping-cart',
        //     a: true,
        //     b: false,
        //     percent: 12
        // }, {
        //     color: 'yellow',
        //     description: '案件總數',
        //     stats: '50',
        //     icon: 'money',
        //     b: true,
        //     a: false,
        //     percent: 77
        // }];

        function query(custType, custId) {

            // var reportStartTime = new Date().getTime();
            // var reportEndTime = new Date().getTime();
            // var params = {};
            // params.start = reportStartTime;
            // params.end = reportEndTime;

            getBonusCase(custType, custId).then(
                function(data) {
                    var _data = data.data;
                    var _dataLength = _data.length;
                    //console.log('data.data: ' + JSON.stringify(data.data));
                    var _percent = parseFloat(_dataLength) / 5 * 100;
                    // if () {

                    // }

                    var _insert = {
                        color: 'red',
                        description: '回饋獎金案件',
                        //description2: '案件累計',
                        stats: _dataLength + '/5',
                        icon: 'shopping-cart',
                        a: true,
                        b: false,
                        percent: _percent
                    };

                    // $scope.charts = [{
                    //     color: 'red',
                    //     description: '已達獎金累計',
                    //     //description2: '123',
                    //     stats: _dataLength + '/5',
                    //     icon: 'shopping-cart',
                    //     a: true,
                    //     b: false,
                    //     percent: 12
                    // }, {
                    //     color: 'yellow',
                    //     description: '案件總數',
                    //     stats: '50',
                    //     icon: 'money',
                    //     b: true,
                    //     a: false,
                    //     percent: 77
                    // }];

                    $scope.charts.push(_insert);
                },
                function() {
                    console.error('Get reports failed!');
                }
            );
        };

        function getBonusCase(custType, custId) {
            return $http.get('/api/bonus-case/' + custType + '/' + custId);
        };

    }
})();




(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('caseList', caseList);

  /** @ngInject */
  function caseList() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/caseList.html'
    };
  }

})();
(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('CustCtrl', CustCtrl)

    /** @ngInject */
    function CustCtrl($scope, $uibModal, $window, custService, userService) {

        console.log('===============WELCOME CustCtrl==========================');
        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$window = $window;
        vm.$uibModal = $uibModal;
        vm.UserService = userService;
        vm.CustService = custService;
        var custId = $window.localStorage.getItem('userId');
        var custType = $window.localStorage.getItem('userType');
        vm.$scope.fmUser = {};
        vm.$scope.fmSubItem = {};
        vm.$scope.items;
        vm.$scope.custType = custType;
        vm.$scope.caseList = [];
        vm.getCaseList(custType, custId);

        $scope.expandMessage = function(message) {
            message.expanded = !message.expanded;
        }
    }

    CustCtrl.prototype.createUser = function(type) {
        var vm = this;
        var user = vm.$scope.fmUser;
        vm.UserService.createUser(user, type).then(function(data) {
                alert('Create user success!');
            },
            function() {
                console.error('Create users failed!');
            }
        );
    }

    CustCtrl.prototype.saveUser = function() {
        var vm = this;
        var user = vm.$scope.fmUser;
        vm.UserService.updateUser(user, user.id).then(
            function(data) {
                alert('Update user success!');
            },
            function() {
                console.error('Update users failed!');
            }
        );
    }

    CustCtrl.prototype.getUers = function(role) {
        var vm = this;
        vm.UserService.getUers(role).then(function(data) {
                if (role === 'all-manager') {
                    vm.sales = data.data;
                } else if (role === 'worker') {
                    vm.workers = data.data;
                }
            },
            function() {
                console.error('Get users failed!');
            }
        );
    };

    CustCtrl.prototype.open = function(userId) {
        var vm = this;
        var css = 'app-modal-window';
        var page = 'app/kungfu/user/user-edit.html';
        var size = 'lg';
        if (userId !== undefined && userId !== '') {
            vm.editUser(userId);
        } else {
            vm.$scope.fmUser = {};
        }

        vm.$uibModal.open({
            //controller: 'UserCtrl as userCtrl',
            scope: vm.$scope,
            animation: true,
            templateUrl: page,
            size: size,
            //windowClass: css,
            resolve: {}
        }).closed.then(function() {
            //window.alert('Modal closed');
            //vm.getWorkerJobs(vm.jobDate); //Refresh data
        });
    };

    CustCtrl.prototype.getCaseList = function(custType, custId) {
        var vm = this;
        vm.CustService.getBonusCase(custType, custId).then(
            function(data) {
                var _list = data.data;
                console.log('_list.length: ' + _list.length);
                var _insert = {};
                var _warrantyDate = new Date();
                for (var i = 0; i < _list.length; i++) {
                    _insert = {};
                    _warrantyDate = new Date(_list[i].warrantyDate);
                    // (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear()
                    _insert.type = 'image-message';
                    _insert.preview = 'cust/ss3.jpg';
                    _insert.date = _list[i].date.substring(0, 10);
                    if (custType !== 'CTH') {
                        _insert.surname = '回饋獎金累計:' + (i + 1) + '/5';
                    }
                    _insert.text = [
                        '工程保固:' + _warrantyDate.getFullYear() + '-' + (_warrantyDate.getMonth() + 1) + '-' + _warrantyDate.getDate(),
                        _list[i].address
                    ];
                    vm.$scope.caseList.push(_insert);
                }

            },
            function() {
                console.error('Get getBonusCase failed!');
            }
        );
    };

    // CustCtrl.prototype.getPromoteD = function() {
    //     var vm = this;
    //     vm.$scope.promoteD = [{
    //         type: 'image-message',
    //         author: '清水模',
    //         surname: '設計公司限定',
    //         desc1: '每平方公尺1500元',
    //         desc2: '清水模地板+PU抗磨每平方公尺1800元',
    //         preview: 'cust/c1.jpg',
    //         link: 'http://www.kobestone.com/assets/img/cust/c1.jpg',
    //         expanded: false,
    //     }, {
    //         type: 'image-message',
    //         author: '文化石清水模',
    //         surname: '39專案 設計師限定',
    //         desc1: '文化石＋清水模 加總～22每平方公尺',
    //         desc2: '特價39000',
    //         preview: 'cust/c2.jpg',
    //         link: 'http://www.kobestone.com/assets/img/cust/c2.jpg',
    //         expanded: false,
    //     }, {
    //         type: 'image-message',
    //         author: 'VIP團購會員',
    //         surname: '文化石 清水模 人造石 長期配合回饋',
    //         desc1: '一年內五場推廣設計案',
    //         desc2: '獎金10000元',
    //         preview: 'cust/pd2.jpg',
    //         link: 'http://www.kobestone.com/assets/img/cust/pd2.jpg',
    //         expanded: false,
    //     }]
    // };


    CustCtrl.prototype.getPromoteCust = function() {
        var vm = this;
        vm.$scope.promoteCust = [{
            type: 'image-message',
            author: '清水模',
            surname: '清水模限定專案',
            desc1: '每平方公尺1900元',
            desc2: '清水模地板+PU抗磨每平方公尺2200元',
            preview: 'cust/d2.jpg',
            preview2: false,
            link: 'http://www.kobestone.com/assets/img/cust/d2.jpg',
            expanded: false,
        }, {
            type: 'image-message',
            author: '文化石清水模',
            surname: '49專案',
            desc1: '文化石＋清水模 加總～25每平方公尺',
            desc2: '特價49000',
            preview: 'cust/d1.jpg',
            preview2: false,
            link: 'http://www.kobestone.com/assets/img/cust/d1.jpg',
            expanded: false,
        }]
    };

    CustCtrl.prototype.getPromoteD = function() {
        var vm = this;
        vm.$scope.promoteD = [{
            type: 'image-message',
            author: '文化石清水模',
            surname: '設計師統包限定',
            desc1: '文化石循環式超優惠價',
            desc2: '設計師統包價約7-8折',
            preview: 'cust/dm_201811001.jpg',
            preview2: false,
            link: 'http://www.kobestone.com/assets/img/cust/dm_201811001.jpg',
            //link2: 'http://www.kobestone.com/assets/img/cust/dm_2018007.jpg',
            expanded: false,
        }, {
            type: 'image-message',
            author: '清水模',
            surname: '手工清水模工程價',
            desc1: '手感平面清水模 每平方公尺1300元',
            desc2: '板模線孔清水模 每平方公尺1400元',
            preview: 'cust/dm_201811002.jpg',
            preview2: false,
            link: 'http://www.kobestone.com/assets/img/cust/dm_201811002.jpg',
            expanded: false,
        }, {           
            type: 'image-message',
            author: '文化石清水模',
            surname: '設計師統包限定',
            desc1: '文化石循環式超優惠價2018版',
            desc2: '2018最強優惠方案',
            preview: 'cust/dm_201811003.jpg',
            preview2: false,
            link: 'http://www.kobestone.com/assets/img/cust/dm_201811003.jpg',
            expanded: false,
        }]
    };

})();

(function() {

    'use strict';

    angular.module('kungfu.job')
        .service('custService', CustService);

    CustService.$inject = ['$http'];

    function CustService($http) {

        this.getBonusCase = function(custType, custId) {
            return $http.get('/api/bonus-case/' + custType + '/' + custId);
        };

    }


})();




(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('promoteCust', promoteCust);

  /** @ngInject */
  function promoteCust() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/promoteCust.html'
    };
  }

})();



(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('promoteDesigner', promoteDesigner);

  /** @ngInject */
  function promoteDesigner() {
    return {
      restrict: 'E',
      controller: 'CustCtrl',
      templateUrl: 'app/kungfu/cust/promoteDesigner.html'
    };
  }

})();
(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('JobCtrl', JobCtrl)
        .directive('ngRightClick', function($parse) {
            return function(scope, element, attrs) {
                var fn = $parse(attrs.ngRightClick);
                element.bind('contextmenu', function(event) {
                    scope.$apply(function() {
                        event.preventDefault();
                        fn(scope, { $event: event });
                    });
                });
            };
        })
        .directive('makeMeGreen', function($timeout) {
            return {
                restrict:'A',
                link:function(scope, elem, attrs){
                    if (scope.$last) {
                        $timeout( function(){
                            //elem.makeMeGreen();
                            scope.makeMeGreen();
                        }, 0)
                    }
                }
            } 
        });

    var years = ['2016', '2017'];
    var months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    var dayList = ['日', '一', '二', '三', '四', '五', '六'];
    var dashboardJobDate = new Date().getTime();

    /** @ngInject */
    function JobCtrl($scope, $uibModal, $document, $mdDialog, $interval, jobService, cityService, userService, Upload) {

        console.log('===============WELCOME JobCtrl==========================');
        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$uibModal = $uibModal;
        vm.$mdDialog = $mdDialog;
        vm.JobService = jobService;
        vm.UserService = userService;
        vm.CityService = cityService;

        //vm.jobModalName = '新增工單'; //編輯工單
        //vm.imgModalName = '照片瀏覽';
        vm.isDesigner = false;
        vm.amountOfDays = 7 * 24 * 60 * 60 * 1000;
        vm.years = years;
        vm.months = months;
        vm.dayList = dayList;
        vm.workers = [];
        vm.sales = [];
        vm.workJobs;

        //Init page
        vm.getWorkers();
        vm.jobDate = dashboardJobDate;
        vm.getWorkerJobs(vm.jobDate);

        // Pull job status by timer
        vm.pullJobStatusByTimer($interval);

        $scope.makeMeGreen = function () {
            $scope.pullJobStatus();
        };

        $scope.pullJobStatus = function() {
            var vm = this;
            checkJobStatus(vm.jobCtrl.workJobs);
        };

        $scope.open = function(curDate, jobId, page, size, subJobType, ev, worker, subJobId) {
            if (subJobType === 0) {
                vm.cancelLeaveConfirm(ev, worker, curDate, subJobId);
            } else {
                var css = 'app-modal-window';
                $scope.fmJob = {};
                $scope.fmJob.withSearchItem = {};
                $scope.fmJob.jobImages = [];
                $scope.subjob_jobId = jobId;
                $scope.curDate = curDate;

                $uibModal.open({
                    // controller: 'SubJobCtrl as subJobCtrl',
                    scope: $scope,
                    animation: true,
                    templateUrl: page,
                    size: size,
                    windowClass: css,
                    backdrop: false,
                    resolve: {}
                }).closed.then(function() {
                    //window.alert('Modal closed');
                    vm.getWorkerJobs(vm.jobDate); //Refresh data
                });
            }
        };
    }

    function checkJobStatus(workJobs) {
        angular.forEach(workJobs, function(value, key) {
            angular.forEach(value, function(value, key) {
                if (value.length !== 0) {
                    for (var i = 0; i < value.length; i++) {
                        var _subJobId = value[i].subJobId;
                        var _jobStatus = value[i].jobStatus;
                        var _workTime = value[i].workTime;
                        var _materialCode = value[i].materialCode;
                        var _flag = false;

                        if (_materialCode !== 'L4' && _materialCode !== 'L5' && _materialCode !== 'L6'
                            && _materialCode !== 'L3') {
                            _flag = isWarnJob(_workTime, 2);
                        }

                        if (_jobStatus !== 0 && _jobStatus !== 2 && !_flag) {
                            _flag = isWarnJob(_workTime, 1);
                        }

                        if (_materialCode === 'L3' && !_flag) {
                            _flag = isWarnJob(_workTime, 1);
                        }

                        if (_flag && _subJobId !== undefined) {
                            var _element = angular.element('#' + _subJobId);
                            _element[0].style.border = "4px red solid";                                                            
                        }
                    }
                }
            });
        });        
    }

    JobCtrl.prototype.pullJobStatusByTimer = function($interval) {
        var vm = this;
        function doPullJobStatus() {
            var _currentDate = new Date();
            var _h = _currentDate.getHours();
            if (_h === 15) {
                var promise = vm.JobService.getWorkerJobs(vm.jobDate);
                promise.then( 
                    function(data) {
                        checkJobStatus(data.data);
                    },
                    function() {
                        console.error('Get getWorkerJobs failed!');
                    } 
                );
            }           
        }
      
        // start timer
        this.timer = $interval(doPullJobStatus, 600000);
    };

    function isWarnJob(workTime, days) {
        var dayMillsSec = parseFloat(days) * 86400000;
        // 15H = 54000000 ms
        var _warnDate = new Date(workTime + 50400000 - dayMillsSec);
        var _currentDate = new Date();

        // If warn date is sunday or SAT should moved up notify.
        if (_warnDate.getDay() === 0) {
            _warnDate.setDate(_warnDate.getDate() - 2);
        } else if (_warnDate.getDay() === 6) {
            _warnDate.setDate(_warnDate.getDate() - 1);
        }

        if (_currentDate.getTime() >= _warnDate.getTime()) {
            return true;
        } else {
            return false;
        }
    } 

    JobCtrl.prototype.isNewJob = function(id) {
        var vm = this;
        var flag = false;
        if (id !== '' && id !== undefined) {
            flag = true;
        }
        return flag;
    }

    JobCtrl.prototype.leaveConfirm = function(ev, worker, date) {
        var vm = this;
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = vm.$mdDialog.confirm()
            .title('請假')
            .textContent(worker + ' 於 ' + date + ' 請假一天?')
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('確認')
            .cancel('取消');
        vm.$mdDialog.show(confirm).then(function() {
            vm.JobService.leaveDay(worker, date).then(
                function(response) {
                    console.log('Day leave reqest success.');
                },
                function(response) {
                    console.log('Day leave reqest failed!');
                }
            ).finally(function() {
                vm.getWorkerJobs(vm.jobDate); //Refresh data
            });

        }, function() {
            //$scope.status = 'You decided to keep your debt.';
        });
    };

    JobCtrl.prototype.cancelLeaveConfirm = function(ev, worker, date, subJobId) {
        var vm = this;
        // Appending dialog to document.body to cover sidenav in docs app
        var confirm = vm.$mdDialog.confirm()
            .title('取消請假')
            .textContent(worker + ' 於 ' + date + ' 取消當天請假?')
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('確認')
            .cancel('取消');
        vm.$mdDialog.show(confirm).then(function() {
            vm.JobService.delSubJob(subJobId).then(
                function(response) {
                    console.log('Cancel day leave reqest success.');
                },
                function(response) {
                    console.log('Cancel day leave reqest failed!');
                }
            ).finally(function() {
                vm.getWorkerJobs(vm.jobDate); //Refresh data
            });

        }, function() {
            //$scope.status = 'You decided to keep your debt.';
        });
    };

    JobCtrl.prototype.getWorkers = function() {
        var vm = this;
        vm.UserService.getWorkers().then(function(data) {
                vm.workers = data.data;
            },
            function() {
                console.error('Get worker failed!');
            }
        );
    };

    JobCtrl.prototype.getUers = function(role) {
        var vm = this;
        vm.UserService.getUers(role).then(function(data) {
                if (role === 'all-manager') {
                    vm.sales = data.data;
                } else if (role === 'worker') {
                    vm.workers = data.data;
                }
            },
            function() {
                console.error('Get users failed!');
            }
        );
    };

    JobCtrl.prototype.getPrevWorkerJobs = function() {
        var vm = this;
        vm.prevTime = vm.jobDate - vm.amountOfDays;
        vm.getWorkerJobs(vm.prevTime);
    };

    JobCtrl.prototype.getNextWorkerJobs = function() {
        var vm = this;
        vm.nextTime = vm.jobDate + vm.amountOfDays;
        vm.getWorkerJobs(vm.nextTime);
    };

    JobCtrl.prototype.getWorkerJobsByYM = function() {
        var vm = this;
        if (vm.queryYear === "" || vm.queryYear === undefined) {
            alert("Please select year!");
            return;
        }
        if (vm.queryMonth === '' || vm.queryMonth === undefined) {
            alert("Please select month!");
            return;
        }
        vm.ym = new Date(parseInt(vm.queryYear), parseInt(vm.queryMonth) - 1, 1).getTime();
        vm.getWorkerJobs(vm.ym);
    };

    JobCtrl.prototype.getWorkerJobs = function(jobDate) {
        var vm = this;
        vm.workJobs = [];
        vm.workDates = [];
        vm.jobDate = jobDate;
        vm.JobService.getWorkerJobs(vm.jobDate).then(function(data) {
                vm.workJobs = data.data;
                //vm.$scope.kkk = data.data; //TODO: TEST
                var values = vm.workJobs;
                //console.log(values);
                var workDates = [];
                var keepGoing = true;
                angular.forEach(values, function(value, key) {
                    //console.log('key: ' + key);
                    //console.log('value: ' + value);
                    if (keepGoing) {
                        angular.forEach(values[key], function(value, key) {
                            var date = new Date(key);
                            var day = date.getDay();
                            var showDay = date.getMonth() + 1 + '/' + date.getDate() + '(' + vm.dayList[day] + ')';
                            this.push(showDay);
                            //this.push(key);
                        }, workDates);
                        keepGoing = false;
                    }
                });
                vm.workDates = workDates;

            },
            function() {
                console.error('Get workerJobs failed!');
            }
        ).finally(function() {
            dashboardJobDate = jobDate;
            vm.jobDate = jobDate;
        });

    };

    JobCtrl.prototype.getSubJobBGColor = function(subJobType) {
        //var bgColor = '#233b80';
        var bgColor = '#fffff0';
        if (subJobType === 0) {
            bgColor = '#9E9E9E';
        }
        return bgColor;
    }

    JobCtrl.prototype.isLeaveDay = function(subJobType) {
        if (subJobType === 0) {
            return true;
        }
        return false;
    }

    JobCtrl.prototype.isWeekend = function(index, type) {
        var vm = this;
        var holiday1;
        var holiday2;
        var bgColor = '#d9edf7';
        if (type === 'header') {
            bgColor = '#1c2b36';
            holiday1 = index.includes("六");
            holiday2 = index.includes("日");
        } else {
            //var day_list1 = ['日', '一', '二', '三', '四', '五', '六'];
            var date1 = new Date(index);
            var day1 = date1.getDay();
            var showDay = vm.dayList[day1];
            holiday1 = showDay.includes("六");
            holiday2 = showDay.includes("日");
        }
        if (holiday1 || holiday2) {
            bgColor = '#3688f4';
        }
        return bgColor;
    };

    JobCtrl.prototype.getWorkerColor = function(worker) {
        var vm = this;
        for (var i = 0; i < vm.workers.length; i++) {
            //console.log('color worker: ' + vm.workers[i].name);
            if (vm.workers[i].name === worker) {
                return vm.workers[i].color;
            }
        }
    };   

})();

(function() {

    'use strict';

    angular.module('kungfu.job')
        .service('jobService', JobService);


    JobService.$inject = ['$http'];

    function JobService($http) {

        this.getCaseRegion = function(params) {
            return $http.get('/api/case-region', {
                params: params
            });
        };

        this.saveJob = function(job) {
            return $http.post('/api/job', job);
        };

        this.updateJob = function(job, jobId) {
            return $http.put('/api/job/' + jobId, job);
        };

        this.saveCopyJob = function(job, copyJobId) {
            return $http.post('/api/copyJob/' + copyJobId, job);
        };

        this.updateJobs = function(jobs) {
            return $http.put('/api/jobs', jobs);
        };

        this.updateJobStatus = function(jobId, status) {
            return $http.put('/api/job/' + jobId + '/status/' + status);
        };

        this.downloadImg = function(jobId) {
            return $http.post('/api/job/ '+ jobId + '/save-images');
        };

        this.getJob = function(jobId) {
            return $http.get('/api/job/' + jobId);
        };

        this.getWorkerJobs = function(startTime, endTime) {
            return $http.get('/api/work-jobs', {
                params: {
                    start: startTime,
                    end: endTime
                }
            });
        };

        this.getSubItems = function(code) {
            return $http.get('/api/subitems/' + code);
        };

        this.getAllSubItems = function() {
            return $http.get('/api/subitems/all');
        };

        this.getWorkers = function() {
            return $http.get('/api/worker');
        };

        this.getUers = function(role) {
            return $http.get('/api/user/' + role);
        };

        this.delSubJob = function(subJobId) {
            return $http.delete('/api/job/sub/' + subJobId);
        };

        this.delJobDetail = function(jobDetailId) {
            return $http.delete('/api/job/detail/' + jobDetailId);
        };

        this.delJob = function(jobId) {
            return $http.delete('/api/job/' + jobId);
        };

        this.leaveDay = function(worker, date) {
            return $http.put('/api/job/leave/' + worker + '/' + date);
        };

    }


})();

(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('SubJobCtrl', SubJobCtrl);

    var dashboardJobDate = new Date().getTime();
    /** @ngInject */
    function SubJobCtrl($window, $scope, $uibModal, $document, $mdDialog, jobService, cityService, userService, Upload, $q) {

        console.log('===============WELCOME SubJobCtrl==========================');
        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$q = $q;
        vm.$uibModal = $uibModal;
        vm.$mdDialog = $mdDialog;
        vm.JobService = jobService;
        vm.UserService = userService;
        vm.CityService = cityService;

        vm.imgModalName = '照片瀏覽';
        //vm.isDesigner = false;
        //vm.isTownHouse = false;
        vm.amountOfDays = 7 * 24 * 60 * 60 * 1000;
        vm.$scope.msgsize = 6;
        vm.$scope.shipsize = 3;
        vm.$scope.isElevators = ['有電梯', '無電梯', '待確認'];
        vm.$scope.yesno = [{ value: true, name: '是' }, { value: false, name: '否' }];
        vm.$scope.townhouseFloor = [{ value: '0', name: '透天' }, { value: '1', name: '1' }, { value: '2', name: '2' },
            { value: '3', name: '3' }, { value: '4', name: '4' }, { value: '5', name: '5' }, { value: 'B1', name: 'B1' }
        ];
        vm.$scope.jobStatus = [{ value: 1, name: '未指派' }, { value: 2, name: '已指派' }, { value: 0, name: '已結案' }];
        vm.subItems = ['wall', 'custType', 'factory', 'corner', 'light', 'slit', 'stoneLight', 'payment', 'brand']; //Get subitems list
        vm.countryList = [];
        vm.workers = [];
        vm.sales = [];
        vm.$scope.fmJob = {};
        vm.$scope.fmJob.jobImages = [];
        vm.$scope.fmJob.jobModalName = '新增工單'; //編輯工單

        $scope.tmpImgPath = 'tmp_' + new Date().getTime();
        $scope.calOpened = false; // 複製工單日曆

        $scope.confirmMaterialLight = function(value) {
            var _stoneLightItems = vm.$scope.stoneLightItems;
            var _lightName = '';
            for (var i = 0; i < _stoneLightItems.length; i++) {
                if (_stoneLightItems[i].id === value) {
                    _lightName = _stoneLightItems[i].name;
                }
            }
            if (_lightName.includes("灰")) {

                var jobId = vm.$scope.fmJob.id;
                if (jobId === '' || jobId === undefined) {
                    vm.$scope.fmJob.materialLight = vm.$scope.fmJob.materialLight_bak;
                    alert('請先儲存工單!');
                    return;
                }

                if (confirm('確認改變為灰燈?')) {
                    $scope.changeLight(0, value);
                    vm.$scope.fmJob.materialLight_bak = value;

                    // vm.JobService.updateJobStatus(jobId, 'assign').then(
                    //     function(response) {
                    //         $scope.changeLight(0, value);
                    //         vm.$scope.fmJob.status = 2;
                    //         vm.$scope.fmJob.materialLight_bak = value;
                    //     },
                    //     function(response) {
                    //         console.log('Update job status failed!');
                    //     }
                    // ).finally(function() {
                    //     //vm.$scope.$close();
                    // });

                } else {
                    vm.$scope.fmJob.materialLight = vm.$scope.fmJob.materialLight_bak;
                }
            } else {
                $scope.changeLight(0, value);
                vm.$scope.fmJob.materialLight_bak = value;
            }

        }

        $scope.consisWorkDetailLight = function(value) {
            for (var i = 0; i < vm.$scope.workDetailSet.length; i++) {
                vm.$scope.workDetailSet[i].light = value;
                $scope.changeLight(i, value, 'array');
            }
        }

        $scope.changeLight = function(index, value, type) {
            var bgColor = '';
            if (type === 'array') {
                bgColor = switchLightBgColor(vm.$scope.lightItems, value);
                vm.$scope.workDetailSet[index]['lightBgColor'] = bgColor;
            } else {
                bgColor = switchLightBgColor(vm.$scope.stoneLightItems, value);
                vm.$scope.fmJob.materialBGColor = bgColor;
            }
        }

        $scope.getWorkers = function() {
            vm.UserService.getWorkersByStatus('ENABLED').then(function(data) {
                    vm.$scope.workers = data.data;
                },
                function() {
                    console.error('Get worker failed!');
                }
            );
        };

        $scope.getUers = function(role) {
            vm.UserService.getUers(role).then(function(data) {
                    if (role === 'all-manager') {
                        vm.$scope.sales = data.data;
                    } else if (role === 'worker') {
                        vm.$scope.workers = data.data;
                    }
                },
                function() {
                    console.error('Get users failed!');
                }
            );
        };

        $scope.selectCust = function(cust) {
            if (cust.id !== null && cust.id !== '' && cust.id !== undefined) {
                vm.$scope.custExist = true;
                vm.$scope.fmJob.custName = cust.name;
                vm.$scope.fmJob.custPhone = cust.phone;
                vm.$scope.fmJob.custType = cust.custType;
                vm.$scope.fmJob.code = cust.line;
                if (cust.company !== null && cust.company !== '' && cust.company !== undefined) {
                    vm.$scope.fmJob.designCompany = cust.company.name;
                }
                $scope.changeCustType(cust.custType);
            } else {
                vm.$scope.custExist = false;
                vm.$scope.fmJob.custName = '';
                vm.$scope.fmJob.custType = '';
                vm.$scope.fmJob.code = '';
                vm.$scope.fmJob.designCompany = '';
                vm.$scope.fmJob.custPhone = cust.phone;
                $scope.changeCustType();
            }
        }

        $scope.getCustPhone = function(phone) {
            if (phone === '' || phone === undefined || phone.length < 4) {
                return;
            }
            var _params = {};
            _params.phone = phone;
            vm.UserService.getCustomersByCondition(_params).then(
                function(data) {
                    var _data = data.data;
                    if (_data === '' || _data === null || _data.length === 0) {
                        _data = [];
                        _data.push({ "phone": phone, 'account': phone });
                    }
                    vm.$scope.custs = _data;
                },
                function() {
                    console.error('Get customers failed!');
                }
            );
        }

        $scope.getAllSubItems = function() {
            try {
                vm.JobService.getAllSubItems().then(
                    function(data) {
                        var allSubItems = data.data;
                        for (var i = 0; i < allSubItems.length; i++) {
                            vm.$scope[allSubItems[i].item + 'Items'] = allSubItems[i].subItems;
                        };
                    },
                    function() {
                        console.error('Get sub items failed!');
                    }
                );
                return true;
            } catch (e) {
                console.log(e);
                return false;
            }
        };

        // $scope.uploadPicXXX = function() {
        //     //var vm = this;
        //     var jobId = $scope.fmJob.id;
        //     if (jobId === '' || jobId === undefined) {
        //         jobId = $scope.tmpImgPath;
        //         $scope.fmJob.tmpImgPath = $scope.tmpImgPath;
        //     }
        //     var file = $scope.file;
        //     if ($scope.subJobForm.file.$valid && $scope.file) {
        //         Upload.upload({
        //             url: '/api/job/' + jobId + '/upload-file',
        //             //data: {file: file, 'username': $scope.username},
        //             method: 'PUT',
        //             data: { file: file },
        //             file: file,
        //         }).then(function(resp) {
        //             console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data.uploadfile);
        //             vm.$scope.fmJob.jobImages.push(resp.data.uploadfile);
        //             //$rootScope.jImgs.push(resp.data.uploadfile);
        //         }, function(resp) {
        //             console.log('Error status: ' + resp.status);
        //         }, function(evt) {
        //             var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
        //             console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
        //         });
        //     }
        // };


        // for multiple files:
        $scope.uploadPic = function() {
            //console.log(xxx);
            var files = $scope.file;
            if (files && files.length) {

                var jobId = $scope.fmJob.id;
                if (jobId === '' || jobId === undefined) {
                    jobId = $scope.tmpImgPath;
                    $scope.fmJob.tmpImgPath = $scope.tmpImgPath;
                }

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    Upload.upload({
                        url: '/api/job/' + jobId + '/upload-file',
                        //data: {file: file, 'username': $scope.username},
                        method: 'PUT',
                        data: { file: file },
                        file: file,
                    }).then(function(resp) {
                        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data.uploadfile);
                        vm.$scope.fmJob.jobImages.push(resp.data.uploadfile);
                        //$rootScope.jImgs.push(resp.data.uploadfile);
                    }, function(resp) {
                        console.log('Error status: ' + resp.status);
                    }, function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
                // or send them all together for HTML5 browsers:
                //Upload.upload({..., data: { file: files }, ... })...;    

            }
        }

        $scope.msin = function() {
            angular.element($document).find(".delete").show();
        }

        $scope.msout = function() {
            angular.element($document).find(".delete").hide();
        }

        $scope.removeImg = function(index) {
            vm.$scope.fmJob.jobImages.splice(index, 1);
        }

        $scope.open1 = function(index) {
            vm.$scope.fmJob.workerJobSet[index].opened = true;
        }

        $scope.calOpen = function() {
            $scope.calOpened = true;
        }

        $scope.saveCopyJob = function() {
            if (vm.$scope.fmJob.copyJobWorker === '' || vm.$scope.fmJob.copyJobWorkTime === '' ||
                vm.$scope.fmJob.copyJobContact === '' || vm.$scope.fmJob.copyJobWorker === undefined ||
                vm.$scope.fmJob.copyJobWorkTime === undefined || vm.$scope.fmJob.copyJobContact === undefined) {
                alert('請確認必填欄位!');
                return;
            }

            var copyJobId = vm.$scope.fmJob.id;
            if (copyJobId === '' || copyJobId === null) {
                alert('工單ID不存在!');
            }
            vm.$scope.fmJob.copyJobId = copyJobId;

            vm.JobService.saveCopyJob(vm.$scope.fmJob, copyJobId).then(
                function(response) {
                    //console.log('Copy job success.');
                    alert('工單複製完成!');
                },
                function(response) {
                    //console.log('Copy job failed!');
                    alert('工單複製失敗!');
                }
            ).finally(function() {
                vm.$scope.$close();
            });
        }

        $scope.changeBrand = function(contactId) {
            var contactName = '';
            for (var i = 0; i < vm.$scope.sales.length; i++) {
                if (vm.$scope.sales[i].id === contactId) {
                    contactName = vm.$scope.sales[i].name;
                }
            }
            if (contactName === '張雯雅') {
                $scope.getBrandByName('B3');
            } else if (contactName === '何雅蕙') {
                $scope.getBrandByName('B2');
            } else {
                $scope.getBrandByName('B1');
            }
        }

        $scope.getBrandByName = function(brandCode) {
            var brandId = '';
            for (var i = 0; i < vm.$scope.brandItems.length; i++) {
                if (vm.$scope.brandItems[i].code === brandCode) {
                    brandId = vm.$scope.brandItems[i].id;
                }
            }
            vm.$scope.fmJob.brand = brandId;
        };

        $scope.changeCustType = function(custType) {
            var custTypeName = '';
            for (var i = 0; i < vm.$scope.custTypeItems.length; i++) {
                if (vm.$scope.custTypeItems[i].id === custType) {
                    custTypeName = vm.$scope.custTypeItems[i].name;
                }
            }
            if (custTypeName === '設計師') {
                vm.$scope.isDesigner = true;
                vm.$scope.msgsize = 4;
            } else {
                vm.$scope.isDesigner = false;
                vm.$scope.fmJob.designCompany = '';
                vm.$scope.msgsize = 6;
            }
        };

        $scope.changeElevator = function(type) {
            if (type === '無電梯') {
                vm.$scope.shipsize = 2;
                vm.$scope.isTownHouse = true;
            } else {
                vm.$scope.shipsize = 3;
                vm.$scope.isTownHouse = false;
                vm.$scope.fmJob.townHouse = '';
            }
        };

        $scope.changePayment = function(id) {
            var payTypeName = '';
            for (var i = 0; i < vm.$scope.paymentItems.length; i++) {
                if (vm.$scope.paymentItems[i].id === id) {
                    payTypeName = vm.$scope.paymentItems[i].name;
                }
            }

            if (payTypeName === '完工收現' || payTypeName === '完工收現給收據' || payTypeName === '完工收支票') {
                //vm.$scope.shipsize = 2;
                vm.$scope.isCasePrePay = true;
            } else {
                //vm.$scope.shipsize = 3;
                vm.$scope.isCasePrePay = false;
                vm.$scope.fmJob.casePrePay = 0;
            }

            $scope.checkCasePrePay(vm.$scope.fmJob.casePiece);
        };

        $scope.checkCasePrePay = function(casePiece) {
            var payTypeName = '';
            for (var i = 0; i < vm.$scope.paymentItems.length; i++) {
                if (vm.$scope.paymentItems[i].id === vm.$scope.fmJob.payment) {
                    payTypeName = vm.$scope.paymentItems[i].name;
                }
            }
            if (payTypeName === '完工收現') {
                if (vm.$scope.fmJob.casePrePay === '' || vm.$scope.fmJob.casePrePay === null ||
                    vm.$scope.fmJob.casePrePay === 0 || vm.$scope.fmJob.casePrePay === undefined) {
                    vm.$scope.fmJob.casePrePay = casePiece;
                }
            }
        }

        $scope.checkPayment = function(id) {
            var payTypeName = '';
            for (var i = 0; i < vm.$scope.paymentItems.length; i++) {
                if (vm.$scope.paymentItems[i].id === id) {
                    payTypeName = vm.$scope.paymentItems[i].name;
                }
            }
            var _casePrePay = parseFloat(vm.$scope.fmJob.casePrePay);
            if (payTypeName === '完工收現') {
                if (convertNullValToZero(_casePrePay) === 0) {
                    return true;
                }
            }
            return false;
        }

        $scope.editJob = function(jobId) {
            vm.JobService.getJob(jobId).then(
                function(data) {
                    var job = data.data;
                    angular.copy(job, vm.$scope.fmJob);
                    if (job.workDetailSet.length != 0) {
                        vm.$scope.workDetailSet = [];
                    } else {
                        vm.$scope.workDetailSet = [{
                            footage: '',
                            stockType: '',
                            slitItem: '',
                            light: '',
                            slit: '',
                            lightBgColor: 'white',
                            factory: '',
                            opened: false,
                            wall: '',
                            corner: '',
                            angelBrickBoxes: '',
                            flatBrickBoxes: '',
                            ship: '',
                            orderNum: '',
                            shipFlatBoxes: '',
                            shipAngelBoxes: '',
                            originAngelBrickBoxes: '',
                            originFlatBrickBoxes: '',
                            originShipFlatBoxes: '',
                            originShipAngelBoxes: ''
                        }];
                    }

                    var _items = job.items;
                    for (var i = 0; i < _items.length; i++) {
                        vm.$scope[_items[i].item + 'Items'] = _items[i].subItems;
                    };

                    for (var i = 0; i < job.workDetailSet.length; i++) {
                        var j = job.workDetailSet[i];
                        var bgColor = switchLightBgColor(vm.$scope.lightItems, j.light);
                        if (bgColor === null || bgColor === '') {
                            bgColor = 'white';
                        }
                        vm.$scope.workDetailSet.push({
                            id: j.id,
                            footage: j.footage,
                            stockType: j.stockType,
                            slitItem: j.slitItem,
                            light: j.light,
                            slit: j.slit,
                            factory: j.factory,
                            lightBgColor: bgColor,
                            opened: false,
                            wall: j.wall,
                            orderNum: j.orderNum,
                            corner: j.corner,
                            ship: j.ship,
                            angelBrickBoxes: j.angelBrickBoxes,
                            flatBrickBoxes: j.flatBrickBoxes,
                            shipFlatBoxes: j.shipFlatBoxes,
                            shipAngelBoxes: j.shipAngelBoxes,
                            originAngelBrickBoxes: j.angelBrickBoxes,
                            originFlatBrickBoxes: j.flatBrickBoxes,
                            originShipFlatBoxes: j.shipFlatBoxes,
                            originShipAngelBoxes: j.shipAngelBoxes
                        });
                    }
                    // sort by workTime
                    vm.$scope.workDetailSet.sort(function(a, b) {
                        return a.orderNum - b.orderNum;
                    });

                    if (job.subJobs.length != 0) {
                        vm.$scope.fmJob.workerJobSet = [];
                    } else {
                        vm.$scope.fmJob.workerJobSet = [{ workers: [{}, {}, {}], workTime: '', opened: false }];
                    }

                    var _workerJobArr = [];
                    //var _workerJobArr2 = [{}, {}, {}];
                    if (job.primaryWorker === undefined) {
                        job.primaryWorker = { id: null };
                    }
                    for (var i = 0; i < job.subJobs.length; i++) {
                        var j = job.subJobs[i];
                        var workerArr = [];
                        var workerArr2 = [];
                        for (var k = 0; k < 3; k++) {
                            if (j.workers[k] === undefined) {
                                workerArr2.push({});
                            } else {
                                if (j.workers[k].id === job.primaryWorker.id && workerArr.length === 0) {
                                    workerArr.push(j.workers[k]);
                                } else {
                                    workerArr2.push(j.workers[k]);
                                }
                            }
                        }
                        Array.prototype.push.apply(workerArr, workerArr2);
                        _workerJobArr.push({ id: j.id, workers: workerArr, workTime: j.workTime, opened: false });
                    }
                    // sort by workTime
                    _workerJobArr.sort(function(a, b) {
                        return a.workTime - b.workTime;
                    });
                    vm.$scope.fmJob.workerJobSet = _workerJobArr;

                    if (job.customer !== null && job.customer !== '' && job.customer !== undefined) {
                        var _custs = [];
                        _custs.push(job.customer);
                        $scope.custs = _custs;
                        vm.$scope.fmJob.withSearchItem = {};
                        vm.$scope.fmJob.withSearchItem.selected = job.customer;
                        $scope.selectCust(job.customer);
                    }

                    //$scope.changeCustType(job.custType);
                    $scope.changeElevator(job.elevator);
                    $scope.changePayment(job.payment);
                    $scope.getDistrict(job.country);
                    vm.$scope.fmJob.materialBGColor = switchLightBgColor(vm.$scope.stoneLightItems, job.materialLight);
                    vm.$scope.fmJob.materialLight_bak = vm.$scope.fmJob.materialLight;
                    if (vm.$scope.fmJob.materialBGColor === null || vm.$scope.fmJob.materialBGColor === '') {
                        vm.$scope.fmJob.materialBGColor = 'white';
                    }
                    vm.$scope.fmJob.originCasePiece = job.casePiece;
                    vm.$scope.fmJob.jobModalName = '編輯工單';
                },
                function(response) {
                    console.log('Get job: ' + jobId + ' failed!');
                }
            ).finally(function() {

            });

        };

        $scope.addInput = function() {
            vm.$scope.fmJob.workerJobSet.push({ workers: [{}, {}, {}], workTime: '', opened: false });
        }

        $scope.checkSpecChar = function(obj) {
            var pattern = /[,#]/g;
            var str = obj.input.stockType;
            var arr = str.match(pattern);
            obj.input.stockType = str.replace(pattern, "");
            if (arr !== null) {
                alert("不可輸入[#][,]字元!");
            }
        }

        $scope.removeInput = function(index) {
            if (vm.$scope.fmJob.workerJobSet.length > 1) {
                if (vm.$scope.fmJob.workerJobSet[index]['id'] != '') {
                    $scope.delSubJob(vm.$scope.fmJob.workerJobSet[index]['id']);
                }
                vm.$scope.fmJob.workerJobSet.splice(index, 1);
            }
        }

        $scope.addWorkDetailInput = function() {
            vm.$scope.workDetailSet.push({
                footage: '',
                stockType: '',
                slitItem: '',
                light: '',
                slit: '',
                factory: '',
                lightBgColor: 'white',
                opened: false,
                wall: '',
                corner: '',
                angelBrickBoxes: '',
                flatBrickBoxes: '',
                orderNum: '',
                shipFlatBoxes: '',
                shipAngelBoxes: ''
            });
        }

        $scope.removeWorkDetailInput = function(index) {
            if (vm.$scope.workDetailSet.length > 1) {
                if (vm.$scope.workDetailSet[index]['id'] != '') {
                    $scope.delJobDetail(vm.$scope.workDetailSet[index]['id']);
                }
                vm.$scope.workDetailSet.splice(index, 1);
            }
        };

        $scope.downloadImg = function() {
            var jobId = vm.$scope.fmJob.id;
            if (jobId === '' || jobId === undefined) {
                alert('請先儲存工單!');
                return;
            }
            for (var i = 0; i < vm.$scope.fmJob.jobImages.length; i++) {
                var location = 'http://' + $window.location.hostname + '/' + vm.$scope.fmJob.jobImages[i];
                var dt = new Date().getTime();
                //console.log('jobImages: ' + location);
                var a = $("<a>").attr('href', location)
                    .attr('download', dt + '.jpg').appendTo("body");
                a[0].click();
                a.remove();
            }

            // vm.JobService.downloadImg(jobId).then(
            //     function(response) {
            //         console.log('Download img success.');
            //     },
            //     function(response) {
            //         console.log('Download img failed!');
            //     }
            // ).finally(function() {});
        };

        $scope.delJob = function() {
            var person = prompt("請輸入刪除工單密碼", "PASSWORD");
            if (person === '2324') {
                if (confirm('確認刪除工單?')) {
                    var jobId = vm.$scope.fmJob.id;
                    console.log('Delete job id: ' + jobId);
                    vm.JobService.delJob(jobId).then(
                        function(response) {
                            console.log('Remove job success.');
                        },
                        function(response) {
                            console.log('Remove job failed!');
                        }
                    ).finally(function() {
                        vm.$scope.$close();
                    });
                }
            } else {
                alert('密碼錯誤!');
            }
        };

        $scope.delSubJob = function(subJobId) {
            vm.JobService.delSubJob(subJobId).then(
                function(response) {
                    console.log('Remove sub job success.');
                },
                function(response) {
                    console.log('Remove sub job failed!');
                }
            ).finally(function() {});
        };

        $scope.delJobDetail = function(jobDetailId) {
            //var vm = this;
            vm.JobService.delJobDetail(jobDetailId).then(
                function(response) {
                    console.log('Remove job detail success.');
                },
                function(response) {
                    console.log('Remove job detail failed!');
                }
            ).finally(function() {

            });
        };

        $scope.isNewJob = function(id) {
            var flag = false;
            if (id !== '' && id !== undefined) {
                flag = true;
            }
            return flag;
        }

        $scope.openImgPreView = function(page, size, img) {
            var css = 'img-modal-window';
            vm.$scope.previewImg = img;
            vm.$scope.isLine = false;
            vm.$uibModal.open({
                controller: 'SubJobCtrl as subJobCtrl',
                scope: vm.$scope,
                animation: true,
                templateUrl: page,
                size: size,
                windowClass: css,
                resolve: {},
            });
        };

        $scope.copyJob = function() {
            var css = 'app-modal-window';
            var page = 'app/kungfu/job/job-copy.html';
            var size = 'md';
            vm.$uibModal.open({
                controller: 'SubJobCtrl as subJobCtrl',
                scope: vm.$scope,
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {}
            }).closed.then(function() {
                //window.alert('Modal closed');
                //vm.getWorkerJobs(vm.jobDate); //Refresh data
            });
        };

        $scope.openLineView = function(page, size, type) {
            var css = 'img-modal-window';
            vm.$scope.lineTxt = combineLineMsg(vm, type, false, $window);
            vm.$scope.isLine = true;
            vm.$uibModal.open({
                controller: 'SubJobCtrl as subJobCtrl',
                scope: vm.$scope,
                animation: true,
                templateUrl: page,
                size: size,
                windowClass: css,
                resolve: {}
            });
        };

        $scope.getCountry = function() {
            vm.$scope.countryList = vm.CityService.getCountry();
        };

        $scope.getDistrict = function(index) {
            if (index !== '' && index !== undefined) {
                vm.$scope.districtList = vm.CityService.getDistrict(index)[0];
            }
        };

        $scope.sendLine = function(type) {
            var message = combineLineMsg(vm, type, true, $window);
            $window.location.href = 'http://line.naver.jp/R/msg/text/' + message;
        };

        $scope.ssave = function() {
            if ($scope.subJobForm.$invalid) {
                alert('請確認必填欄位!');
                return;
            }

            var _firstday_workTime = 0;
            for (var i = 0; i < vm.$scope.fmJob.workerJobSet.length; i++) {
                var _job = vm.$scope.fmJob.workerJobSet[i];
                var _flag = true;
                for (var j = 0; j < _job.workers.length; j++) {
                    var _worker = _job.workers[j];
                    if (_worker.id !== '' && _worker.id !== undefined && _worker.id !== null) {
                        _flag = false;

                        if ((_firstday_workTime === 0 || _job.workTime < _firstday_workTime) && j === 0) {
                            //最早日期的第一順位為主要師傅
                            _firstday_workTime = _job.workTime;
                            vm.$scope.fmJob.primaryWorker = {};
                            vm.$scope.fmJob.primaryWorker.id = _worker.id;
                        }
                    }

                }
                if (_flag) {
                    alert('請選擇師傅!');
                    return;
                }
            }

            if ($scope.checkPayment(vm.$scope.fmJob.payment)) {
                alert('[完工現收]代收不可為0!');
                return;
            }

            var jobId = vm.$scope.fmJob.id;
            for (var i = 0; i < vm.$scope.workDetailSet.length; i++) {
                vm.$scope.workDetailSet[i].orderNum = i + 1;

                //Check materialFactoryFee & materialStockFee is modify
                if (jobId !== '' && jobId !== undefined) {
                    var _abs = convertNullValToZero(vm.$scope.workDetailSet[i].angelBrickBoxes);
                    var _fbs = convertNullValToZero(vm.$scope.workDetailSet[i].flatBrickBoxes);
                    var _sfbs = convertNullValToZero(vm.$scope.workDetailSet[i].shipFlatBoxes);
                    var _sabs = convertNullValToZero(vm.$scope.workDetailSet[i].shipAngelBoxes);
                    var _o_abs = convertNullValToZero(vm.$scope.workDetailSet[i].originAngelBrickBoxes);
                    var _o_fbs = convertNullValToZero(vm.$scope.workDetailSet[i].originFlatBrickBoxes);
                    var _o_sfbs = convertNullValToZero(vm.$scope.workDetailSet[i].originShipFlatBoxes);
                    var _o_sabs = convertNullValToZero(vm.$scope.workDetailSet[i].originShipAngelBoxes);
                    if (_abs !== _o_abs || _fbs !== _o_fbs) {
                        vm.$scope.fmJob.updateMaterialFactory = true;
                    }
                    if (_sfbs !== _o_sfbs || _sabs !== _o_sabs) {
                        vm.$scope.fmJob.updateMaterialStock = true;
                    }
                }
            }

            var _cp = convertNullValToZero(vm.$scope.fmJob.casePiece);
            var _o_cp = convertNullValToZero(vm.$scope.fmJob.originCasePiece);
            if (_cp !== _o_cp && vm.$scope.fmJob.invoice === true) {
                vm.$scope.fmJob.updateCasePrice = true;
            }

            if (vm.$scope.workDetailSet.length != 0) {
                vm.$scope.fmJob.factory = vm.$scope.workDetailSet[0].factory;
            }

            //CUSTOMER
            if (vm.$scope.fmJob.withSearchItem !== undefined && vm.$scope.fmJob.withSearchItem !== '') {
                var _cust_id = vm.$scope.fmJob.withSearchItem.selected.id;
                if (_cust_id === '' || _cust_id === undefined || _cust_id === null) {
                    var _customer = {};
                    _customer.name = vm.$scope.fmJob.custName;
                    _customer.custType = vm.$scope.fmJob.custType;
                    _customer.line = vm.$scope.fmJob.code;
                    _customer.phone = vm.$scope.fmJob.withSearchItem.selected.phone;
                    _customer.account = vm.$scope.fmJob.withSearchItem.selected.phone;
                    vm.$scope.fmJob.customer = _customer;
                } else {
                    if (vm.$scope.fmJob.customer !== '' && vm.$scope.fmJob.customer !== undefined && vm.$scope.fmJob.customer !== null) {
                        vm.$scope.fmJob.customer.id = _cust_id;
                    } else {
                        vm.$scope.fmJob.customer = {};
                        vm.$scope.fmJob.customer.id = _cust_id;
                    }
                }
            }


            vm.$scope.fmJob.subJobs = vm.$scope.fmJob.workerJobSet;
            vm.$scope.fmJob.workDetailSet = vm.$scope.workDetailSet;
            if (vm.$scope.fmJob.district !== '' && vm.$scope.fmJob.district !== undefined) {
                var dList = vm.$scope.districtList;
                vm.$scope.fmJob.districtName = dList[vm.$scope.fmJob.district];
            }
            if (vm.$scope.fmJob.country !== '' && vm.$scope.fmJob.country !== undefined) {
                var cList = vm.$scope.countryList;
                vm.$scope.fmJob.countryName = cList[vm.$scope.fmJob.country];
            }

            if (jobId !== '' && jobId !== undefined) {
                //console.log('===vm.$scope.fmJob====>' + JSON.stringify(vm.$scope.fmJob));
                vm.JobService.updateJob(vm.$scope.fmJob, jobId).then(
                    function(response) {
                        console.log('Update job success.');
                    },
                    function(response) {
                        console.log('Update job failed!');
                    }
                ).finally(function() {
                    vm.$scope.$close();
                });
            } else {
                vm.JobService.saveJob(vm.$scope.fmJob).then(
                    function(response) {
                        console.log('Create job success.');
                    },
                    function(response) {
                        console.log('Create job failed!');
                    }
                ).finally(function() {
                    vm.$scope.$close();
                });
            }

        };

        //Init page
        vm.jobDate = dashboardJobDate;
        $scope.getWorkers();
        $scope.getCountry();
        $scope.getUers('all-manager');

        var sJobId = vm.$scope.subjob_jobId;
        if (sJobId !== '' && sJobId !== null && sJobId !== undefined) {
            //Get edit data
            $scope.editJob(sJobId);
        } else {
            var curDate = vm.$scope.curDate;
            $scope.getAllSubItems();
            vm.$scope.workDetailSet = [{
                footage: '',
                stockType: '',
                slitItem: '',
                light: '',
                slit: '',
                lightBgColor: 'white',
                factory: '',
                opened: false,
                orderNum: '',
                wall: '',
                corner: '',
                angelBrickBoxes: '',
                flatBrickBoxes: '',
                ship: '',
                shipFlatBoxes: '',
                shipAngelBoxes: ''
            }];
            vm.$scope.fmJob.workerJobSet = [{ workers: [{}, {}, {}], workTime: '', opened: false }];
            vm.$scope.fmJob.materialBGColor = 'white';
        }

        // var promise = asyncSubItems($q, $scope);
        // promise.then(function(message) {
        //     console.log('=====promise message==========>' + message);
        //     var sJobId = vm.$scope.subjob_jobId;
        //     $scope.getWorkers();
        //     $scope.getCountry();
        //     $scope.getUers('all-manager');
        //     if (sJobId !== '' && sJobId !== null && sJobId !== undefined) {
        //         //Get edit data
        //         $scope.editJob(sJobId);
        //     } else {
        //         var curDate = vm.$scope.curDate;
        //         console.log('curDate: ' + curDate);
        //         vm.$scope.workDetailSet = [{ footage: '', stockType: '', slitItem: '', light: '', slit: '', lightBgColor: '#337ab7', opened: false }];
        //         vm.$scope.fmJob.workerJobSet = [{ workers: [{}, {}, {}], workTime: '', opened: false }];
        //         vm.$scope.fmJob.materialBGColor = '#337ab7';
        //     }
        // }, function(reason) {
        //     alert('Failed: ' + reason);
        // });

    }

    function convertNullValToZero(val) {
        if (val === undefined || val === null || val === '' || val === '0' || isNaN(val)) {
            return 0;
        }
        return val;
    }

    function asyncSubItems($q, $scope) {
        // perform some asynchronous operation, resolve or reject the promise when appropriate.
        return $q(function(resolve, reject) {
            setTimeout(function() {
                //$scope.getAllSubItems
                //if ($scope.getAllSubItem()) {
                if ($scope.getAllSubItems()) {
                    resolve('Get AllSubItem Success.');
                } else {
                    reject('Get AllSubItem failed.');
                }
            }, 1000);
        });
    }

    function switchLightBgColor(lightItems, value) {
        var lightName = '';
        var bgColor = '';
        for (var i = 0; i < lightItems.length; i++) {
            if (lightItems[i].id === value) {
                //lightName = lightItems[i].name;
                bgColor = lightItems[i].color;
            }
        }
        return bgColor;
    }

    function getItemName(items, id) {
        var _name = '';
        for (var i = 0; i < items.length; i++) {
            if (items[i].id === id) {
                _name = items[i].name;
            }
        }
        return _name;
    }

    function combineLineMsg(vm, type, isMobile, winObj) {
        var message = '';
        var _address = '',
            _country = '',
            _district = '',
            _detail_address = '',
            _all_date = '',
            _footage = 0,
            _stockType = '',
            _custName = '',
            _custPhone = '',
            _workDesc = '',
            _shipDesc = '',
            _ship = '',
            _casePrePay = '',
            _workPiece = '',
            _managetMessage = '',
            _supportMessage = '',
            _contact = '',
            _line = '',
            _casePiece = '',
            _designCompany = '',
            _primaryWorker = '',
            _material = '',
            _material_number = '';

        var _break = '\r\n';
        if (isMobile) {
            _break = '%0D%0A';
        }

        for (var i = 0; i < vm.$scope.fmJob.workerJobSet.length; i++) {
            if (vm.$scope.fmJob.workerJobSet[i].workTime !== undefined && vm.$scope.fmJob.workerJobSet[i].workTime !== '') {
                var _date = new Date(vm.$scope.fmJob.workerJobSet[i].workTime);
                var _str_date = '';
                if (i == 0) {
                    _str_date = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();
                } else {
                    _str_date = (_date.getMonth() + 1) + '-' + _date.getDate();
                }
                _all_date += _str_date + ',';
            }
        }
        var _wall_warning = false;
        var _s_footage;
        for (var i = 1; i <= vm.$scope.workDetailSet.length; i++) {
            if (vm.$scope.workDetailSet[i - 1].footage !== undefined && vm.$scope.workDetailSet[i - 1].footage !== '') {
                // _footage += parseFloat(vm.$scope.workDetailSet[i - 1].footage);
            }
            if (vm.$scope.workDetailSet[i - 1].footage !== undefined && vm.$scope.workDetailSet[i - 1].footage !== '') {
                _s_footage = vm.$scope.workDetailSet[i - 1].footage;
                _footage += parseFloat(vm.$scope.workDetailSet[i - 1].footage);
            } else {
                _s_footage = 0;
            }
            var _slitItem = '';
            if (vm.$scope.workDetailSet[i - 1].slit !== undefined && vm.$scope.workDetailSet[i - 1].slit !== '') {
                _slitItem = '[' + getItemName(vm.$scope.slitItems, vm.$scope.workDetailSet[i - 1].slit) + ']';
            }
            var _wallItem = '';
            if (vm.$scope.workDetailSet[i - 1].wall !== undefined && vm.$scope.workDetailSet[i - 1].wall !== '') {
                var _wall_info = getItemName(vm.$scope.wallItems, vm.$scope.workDetailSet[i - 1].wall);
                _wallItem = '[' + _wall_info + ']';
                if (_wall_info === '嚴重壁癌' || _wall_info === '夾板有漆' || _wall_info === '夾板無漆') {
                    _wall_warning = true;
                }
            }
            var _cornerItem = '';
            if (vm.$scope.workDetailSet[i - 1].corner !== undefined && vm.$scope.workDetailSet[i - 1].corner !== '') {
                _cornerItem = '[' + getItemName(vm.$scope.cornerItems, vm.$scope.workDetailSet[i - 1].corner) + ']';
            }
            var _shipAngelBoxes = 0;
            if (vm.$scope.workDetailSet[i - 1].shipAngelBoxes !== '' && vm.$scope.workDetailSet[i - 1].shipAngelBoxes !== undefined) {
                _shipAngelBoxes = vm.$scope.workDetailSet[i - 1].shipAngelBoxes;
            }
            var _shipFlatBoxes = 0;
            if (vm.$scope.workDetailSet[i - 1].shipFlatBoxes !== '' && vm.$scope.workDetailSet[i - 1].shipFlatBoxes !== undefined) {
                _shipFlatBoxes = vm.$scope.workDetailSet[i - 1].shipFlatBoxes;
            }
            var _angelBrickBoxes = 0;
            if (vm.$scope.workDetailSet[i - 1].angelBrickBoxes !== '' && vm.$scope.workDetailSet[i - 1].angelBrickBoxes !== undefined) {
                _angelBrickBoxes = vm.$scope.workDetailSet[i - 1].angelBrickBoxes;
            }
            var _flatBrickBoxes = 0;
            if (vm.$scope.workDetailSet[i - 1].flatBrickBoxes !== '' && vm.$scope.workDetailSet[i - 1].flatBrickBoxes !== undefined) {
                _flatBrickBoxes = vm.$scope.workDetailSet[i - 1].flatBrickBoxes;
            }

            var _st = vm.$scope.workDetailSet[i - 1].stockType;
            //var _mt = '平' + _flatBrickBoxes + '角' + _angelBrickBoxes;
            var _mt = '';
            if (_flatBrickBoxes != 0 && _flatBrickBoxes != null) {
                _mt += '平' + _flatBrickBoxes;
            }
            if (_angelBrickBoxes != 0 && _angelBrickBoxes != null) {
                _mt += '角' + _angelBrickBoxes;
            }
            //var _ship_mt = '平' + _shipFlatBoxes + '角' + _shipAngelBoxes;
            var _ship_mt = '';
            if (_shipFlatBoxes != 0 && _shipFlatBoxes != null) {
                _ship_mt += '平' + _shipFlatBoxes;
            }
            if (_shipAngelBoxes != 0 && _shipAngelBoxes != null) {
                _ship_mt += '角' + _shipAngelBoxes;
            }

            _stockType += '(' + i + ')' + _st + '[' + _s_footage + '坪]' + _slitItem + _wallItem + _cornerItem + _break;

            if (_st !== '') {
                _material_number += '(' + i + ')' + _st + '*' + _mt;
                _managetMessage += '(' + i + ')' + _st + '*' + _mt;
                if (_ship_mt != '') {
                    _material_number += '(自載)' + _st + '*' + _ship_mt + _break;
                    _managetMessage += '(自載)' + _st + '*' + _ship_mt + _break;
                } else {
                    _material_number += _break;
                    _managetMessage += _break;
                }
            }

        }

        if (vm.$scope.fmJob.country !== undefined && vm.$scope.fmJob.country !== '') {
            _country = vm.$scope.countryList[vm.$scope.fmJob.country];
        }

        if (vm.$scope.fmJob.address !== undefined && vm.$scope.fmJob.address !== '') {
            _detail_address = vm.$scope.fmJob.address;
        }

        if (vm.$scope.fmJob.district !== undefined && vm.$scope.fmJob.district !== '') {
            _district = vm.$scope.districtList[vm.$scope.fmJob.district];
        }

        if (vm.$scope.fmJob.custName !== undefined && vm.$scope.fmJob.custName !== '') {
            _custName = vm.$scope.fmJob.custName;
        }

        if (vm.$scope.fmJob.custPhone !== undefined && vm.$scope.fmJob.custPhone !== '') {
            _custPhone = vm.$scope.fmJob.custPhone;
        }

        if (vm.$scope.fmJob.isHome === true) {
            _workDesc += '[居家]';
        }

        if (_wall_warning) {
            _workDesc += '[使用曲巧泥]';
        }

        //console.log('vm.$scope.brandItems:' + vm.$scope.brandItems);
        var _brandCode = '';
        for (var i = 0; i < vm.$scope.brandItems.length; i++) {
            if (vm.$scope.brandItems[i].id === vm.$scope.fmJob.brand) {
                _brandCode = vm.$scope.brandItems[i].code;
            }
        }

        if (_brandCode !== 'B1' && _brandCode !== '') {
            _workDesc += '[非陳師傅, 不用保固]';
        }

        if (vm.$scope.fmJob.workDesc !== undefined && vm.$scope.fmJob.workDesc !== '') {
            _workDesc += vm.$scope.fmJob.workDesc;
        }

        if (vm.$scope.fmJob.elevator !== undefined && vm.$scope.fmJob.elevator !== '') {
            _shipDesc = vm.$scope.fmJob.elevator;
        }

        if (vm.$scope.fmJob.elevator === '無電梯' && vm.$scope.fmJob.townHouse !== '' && vm.$scope.fmJob.townHouse !== null && vm.$scope.fmJob.townHouse !== undefined) {

            if (vm.$scope.fmJob.townHouse === 'B1') {
                _shipDesc += '[B1]';
            } else if (vm.$scope.fmJob.townHouse === '0') {
                _shipDesc += '[' + vm.$scope.townhouseFloor[vm.$scope.fmJob.townHouse].name + ']';
            } else {
                _shipDesc += '[' + vm.$scope.townhouseFloor[vm.$scope.fmJob.townHouse].name + 'F]';
            }
        }

        if (vm.$scope.fmJob.shipDesc !== undefined && vm.$scope.fmJob.shipDesc !== '') {
            _shipDesc += ' ' + vm.$scope.fmJob.shipDesc;
        }

        if (vm.$scope.fmJob.ship !== undefined && vm.$scope.fmJob.ship !== '') {
            _ship += vm.$scope.fmJob.ship;
        }

        if (vm.$scope.fmJob.casePrePay !== undefined && vm.$scope.fmJob.casePrePay !== '') {
            _casePrePay = vm.$scope.fmJob.casePrePay;
        }

        if (vm.$scope.fmJob.workPiece !== undefined && vm.$scope.fmJob.workPiece !== '') {
            _workPiece = vm.$scope.fmJob.workPiece;
        }

        if (vm.$scope.fmJob.material !== undefined && vm.$scope.fmJob.material !== '') {
            _material += vm.$scope.fmJob.material;
        }

        if (vm.$scope.fmJob.managetMessage !== undefined && vm.$scope.fmJob.managetMessage !== '') {
            _managetMessage += vm.$scope.fmJob.managetMessage;
        }

        if (vm.$scope.fmJob.supportMessage !== undefined && vm.$scope.fmJob.supportMessage !== '') {
            _supportMessage += vm.$scope.fmJob.supportMessage;
        }

        var account = winObj.localStorage.getItem('user');
        if (account === 'c001' || account === 'c003') {
            if (vm.$scope.fmJob.contact !== undefined && vm.$scope.fmJob.contact !== '') {
                _contact = vm.$scope.fmJob.contact.name;
            }
            if (vm.$scope.fmJob.code !== undefined && vm.$scope.fmJob.code !== '') {
                _line = vm.$scope.fmJob.code;
            }
            if (vm.$scope.fmJob.casePiece !== undefined && vm.$scope.fmJob.casePiece !== '') {
                _casePiece = vm.$scope.fmJob.casePiece;
            }
            if (vm.$scope.fmJob.designCompany !== undefined && vm.$scope.fmJob.designCompany !== '') {
                _designCompany = vm.$scope.fmJob.designCompany;
            }
            if (vm.$scope.fmJob.primaryWorker !== undefined && vm.$scope.fmJob.primaryWorker !== '') {
                _primaryWorker = vm.$scope.fmJob.primaryWorker.name;
            }
        }

        _address = _country + _district + _detail_address;

        var _custType = getItemName(vm.$scope.custTypeItems, vm.$scope.fmJob.custType);
        //var _wall = getItemName(vm.$scope.wallItems, vm.$scope.fmJob.wall);
        //var _corner = getItemName(vm.$scope.cornerItems, vm.$scope.fmJob.corner);

        if (type === 0) {
            message = '施工日: ' + _all_date + _break +
                '地址: ' + _address + _break +
                '業主: ' + _custName + _break +
                '電話: ' + _custPhone + _break +
                '身份: ' + _custType + _break +
                '搬運備註: ' + _shipDesc + _break +
                '施工坪數: ' + _footage.toFixed(2) + '坪' + _break +
                '備貨型號: ' + _break + _stockType + _break +
                '生管留言: ' + _managetMessage + _break + _supportMessage;
        } else {
            message = '施工日: ' + _all_date + _break +
                '地址: ' + _address + _break +
                '業主: ' + _custName + _break +
                '電話: ' + _custPhone + _break +
                '身份: ' + _custType + _break +
                '施工注意/說明: ' + _workDesc + _break +
                //'牆面: ' + _wall + _break +
                //'轉角: ' + _corner + _break +
                '搬運備註: ' + _shipDesc + _break +
                '施工坪數: ' + _footage.toFixed(2) + '坪' + _break +
                '備貨型號: ' + _break + _stockType +
                //'自載: ' + _ship + _break +
                '代收: ' + _casePrePay + _break +
                '工資: ' + _workPiece + _break +
                '石材狀況: ' + _material_number + _material + _break;

            if (account === 'c001' || account === 'c003') {
                message += _break + '業務: ' + _contact + _break +
                    'Line: ' + _line + _break +
                    '工程款: ' + _casePiece + _break +
                    '設計公司: ' + _designCompany + _break +
                    '師傅: ' + _primaryWorker + _break;
            }
        }

        return message;
    }

})();




(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('cust', cust);

  /** @ngInject */
  function cust() {
    return {
      restrict: 'E',
      controller: 'UserCtrl',
      templateUrl: 'app/kungfu/user/custDashborad.html'
    };
  }

})();



(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('custCaseBarChart', custCaseBarChart);

  /** @ngInject */
  function custCaseBarChart() {
    return {
      restrict: 'E',
      controller: 'ChartCtrl',
      templateUrl: 'app/kungfu/chart/custCaseBarChart.html'
    };
  }

})();



(function () {
  'use strict';

  angular.module('kungfu.job')
      .directive('custSaleGanttChart', custSaleGanttChart);

  /** @ngInject */
  function custSaleGanttChart() {
    return {
      restrict: 'E',
      controller: 'GanttCtrl',
      scope: true,
      templateUrl: 'app/kungfu/chart/custSaleGanttChart.html'
    };
  }

})();
(function() {
    'use strict';

    angular.module('kungfu.job')
        .controller('UserCtrl', UserCtrl)

    // //var $injector = angular.injector(['kungfu.job']);


    // console.log('CommonCtrl=====>' + CommonCtrl);

    // UserCtrl.prototype = Object.create(CommonCtrl.prototype);

    /** @ngInject */
    function UserCtrl($scope, $uibModal, $window, $stateParams, $uibModalStack, $injector, $document,
        $timeout, $q, $log, Upload, userService, itemService, cityService, baConfig, baUtil) {

        console.log('===============WELCOME UserCtrl==========================');
        //Extend CommonCtrl
        //var CommonCtrl = angular.extend(this, $controller('CommonCtrl', { $scope: $scope }));

        //Base Setting
        var vm = this;
        vm.$scope = $scope;
        vm.$window = $window;
        vm.$uibModal = $uibModal;
        vm.UserService = userService;
        vm.ItemService = itemService;
        vm.CityService = cityService;

        // 報表權限
        var account = $window.localStorage.getItem('user');
        if (account === 'c999') {
            vm.$scope.showXXX = true;
        }

        //判斷是否為使用者頁
        if ($stateParams.user !== undefined) {
            vm.$scope.fmUser = {};
            vm.getUers('worker');
        } else if ($stateParams.cust !== undefined) {
            //CUST PAGE
            vm.$scope.fmCust = {};
            vm.$scope.fmCust.jobImages = [];
            vm.$scope.tmpImgPath = 'tmp_' + new Date().getTime();
            vm.getCustTypeSubItems();
            vm.getCompanys();
            vm.getTableCustomers();
            vm.getCountry();
            //var CommonCtrl = $injector.get('CommonCtrl');
            //CommonCtrl.call(vm, $scope, vm.$scope.fmCust, 'user');

            vm.$scope.originlList = [
                { value: '＠2016', name: '＠2016' },
                { value: '＠2012', name: '＠2012' },
                { value: 'L0920', name: 'L0920' },
                { value: 'L0982', name: 'L0982' },
                { value: 'L099', name: 'L099' },
                { value: 'L0921', name: 'L0921' },
                { value: 'Other', name: 'Other' }
            ];

        } else if ($stateParams.company !== undefined) {
            //COMPANY PAGE
            vm.$scope.fmCompany = {};
            vm.getTableCompanys();
        } else if ($stateParams.bonus !== undefined) {
            //BONUS PAGE
            vm.$scope.fmBonus = {};
            vm.getBonusOfCases();
        }

        vm.smartTableDataPageSize = 20;

        $scope.openCustomer = function(item) {
            vm.$scope.fmCust = {};
            vm.$scope.previewImg = '';
            vm.withSearchItem = {};
            if (item !== null && item !== undefined && item !== '') {
                vm.$scope.fmCust = item;
                if (vm.$scope.fmCust.company !== '' || vm.$scope.fmCust.company !== undefined) {
                    vm.withSearchItem.selected = vm.$scope.fmCust.company;
                }
            }
            var css = 'app-modal-window';
            var page = 'app/kungfu/user/sub-cust.html';
            var size = 'lg';
            vm.$uibModal.open({
                //controller: 'UserCtrl as userCtrl',
                scope: vm.$scope,
                animation: true,
                templateUrl: page,
                windowClass: css,
                size: size,
                resolve: {
                    //  custForm: function () {
                    //     return vm.$scope.custForm;
                    // }                   
                }
            }).closed.then(function() {
                //window.alert('Modal closed');
            });
        };

        $scope.cancelPopWin = function() {
            $uibModalStack.dismissAll('closing');
        }

        // for multiple files:
        $scope.uploadPic = function() {

            var files = vm.$scope.fmCust.file;
            if (files && files.length) {

                var jobId = vm.$scope.fmCust.oId;
                if (jobId === '' || jobId === undefined) {
                    jobId = vm.$scope.tmpImgPath;
                    vm.$scope.fmCust.tmpImgPath = vm.$scope.tmpImgPath;
                }

                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    Upload.upload({
                        url: '/api/job/' + jobId + '/upload-file',
                        //data: {file: file, 'username': $scope.username},
                        method: 'PUT',
                        data: { file: file },
                        file: file,
                    }).then(function(resp) {
                        console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data.uploadfile);
                        vm.$scope.fmCust.jobImages.push(resp.data.uploadfile);
                        //$rootScope.jImgs.push(resp.data.uploadfile);
                    }, function(resp) {
                        console.log('Error status: ' + resp.status);
                    }, function(evt) {
                        var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                        console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                    });
                }
                // or send them all together for HTML5 browsers:
                //Upload.upload({..., data: { file: files }, ... })...;    

            }
        }

        $scope.msin = function() {
            angular.element($document).find(".delete").show();
        }

        $scope.msout = function() {
            angular.element($document).find(".delete").hide();
        }

        $scope.removeImg = function(index) {
            vm.$scope.fmCust.jobImages.splice(index, 1);
        }

    }

    UserCtrl.prototype.getCountry = function() {
        var vm = this;
        vm.$scope.countryList = vm.CityService.getCountry();
    };

    UserCtrl.prototype.getTableCustomers = function(query) {
        var vm = this;
        vm.smartTableData = [];
        vm.smartTableData1 = [];
        if (query) {
            var _params = {};
            _params.name = vm.$scope.fmCust.qName;
            _params.phone = vm.$scope.fmCust.qPhone;
            _params.line = vm.$scope.fmCust.qLine;
            _params.company = vm.$scope.fmCust.qCompany;
            vm.UserService.getCustomersByCondition(_params).then(
                function(data) {
                    var _list = data.data;
                    for (var i = 0; i < _list.length; i++) {
                        _list[i].oId = _list[i].id;
                        _list[i].id = i + 1;
                        _list[i].custTypeName = vm.getCustTypeName(_list[i].custType);
                        vm.smartTableData.push(_list[i]);
                    }
                    vm.smartTableData1 = vm.smartTableData;
                },
                function() {
                    console.error('Get getCustomers failed!');
                }
            );
        } else {
            vm.UserService.getCustomers().then(
                function(data) {
                    var _list = data.data;
                    for (var i = 0; i < _list.length; i++) {
                        _list[i].oId = _list[i].id;
                        _list[i].id = i + 1;
                        _list[i].custTypeName = vm.getCustTypeName(_list[i].custType);
                        vm.smartTableData.push(_list[i]);
                    }
                    vm.smartTableData1 = vm.smartTableData;
                },
                function() {
                    console.error('Get getCustomers failed!');
                }
            );
        }
    };

    UserCtrl.prototype.saveCustomer = function(id) {
        var vm = this;
        var _cust = vm.$scope.fmCust;
        if (vm.withSearchItem.selected !== 'undefined' && vm.withSearchItem.selected !== '') {
            _cust.company = vm.withSearchItem.selected;
        }

        if (_cust.phone === '' || _cust.phone === null || _cust.phone === undefined) {
            alert('請輸入客戶電話！');
            return;
        }

        if (id === '' || id === undefined || id === null) {
            _cust.id = '';
            _cust.account = _cust.phone;
            _cust.status = 1;
            vm.UserService.createCustomer(_cust).then(
                function(data) {
                    var _customer = data.data;
                    _customer.oId = _customer.id;
                    _customer.id = vm.smartTableData.length + 1;
                    vm.smartTableData.push(_customer);
                    alert('Create customer success!');
                    vm.$scope.cancelPopWin();
                },
                function() {
                    console.error('Create customer failed!');
                }
            );
        } else {
            _cust.account = _cust.phone;
            vm.UserService.updateCustomer(_cust, id).then(
                function(data) {
                    alert('Update customer success!');
                    vm.$scope.cancelPopWin();
                },
                function() {
                    console.error('Update customer failed!');
                }
            );
        }
    }

    UserCtrl.prototype.editCompany = function(item) {
        var vm = this;
        item.edit = true;
    };

    UserCtrl.prototype.cancel = function(item) {
        var vm = this;
        item.edit = false;
    }

    UserCtrl.prototype.getBonusOfCases = function() {
        var vm = this;
        vm.smartTableData = [];
        vm.smartTableData1 = [];
        var _params = {};
        // _params.name = vm.$scope.fmCust.qName;
        // _params.phone = vm.$scope.fmCust.qPhone;
        // _params.line = vm.$scope.fmCust.qLine;
        // _params.company = vm.$scope.fmCust.qCompany;
        vm.UserService.getBonusOfCases(_params).then(
            function(data) {
                console.log('SSSSS===>' + JSON.stringify(data.data));
                var _list = data.data;
                for (var i = 0; i < _list.length; i++) {
                    _list[i].oId = _list[i].id;
                    _list[i].id = i + 1;
                    //_list[i].custTypeName = vm.getCustTypeName(_list[i].custType);
                    vm.smartTableData.push(_list[i]);
                }
                vm.smartTableData1 = vm.smartTableData;
            },
            function() {
                console.error('Get getBonusOfCases failed!');
            }
        );

    };

    UserCtrl.prototype.getCompanys = function() {
        var vm = this;
        vm.UserService.getCompanys().then(
            function(data) {
                vm.companys = data.data;
            },
            function() {
                console.error('Get companys failed!');
            }
        );
    };

    UserCtrl.prototype.getTableCompanys = function(query) {
        var vm = this;
        vm.smartTableData = [];
        vm.smartTableData1 = [];
        if (query) {
            var _params = {};
            _params.name = vm.$scope.fmCompany.qName;
            _params.phone = vm.$scope.fmCompany.qPhone;
            vm.UserService.getCompanysByCondition(_params).then(
                function(data) {
                    var _companys = data.data;
                    for (var i = 0; i < _companys.length; i++) {
                        _companys[i].oId = _companys[i].id;
                        _companys[i].id = i + 1;
                        _companys[i].edit = false;
                        vm.smartTableData.push(_companys[i]);
                    }
                    vm.smartTableData1 = vm.smartTableData;
                },
                function() {
                    console.error('Get companys failed!');
                }
            );

        } else {
            vm.UserService.getCompanys().then(
                function(data) {
                    var _companys = data.data;
                    for (var i = 0; i < _companys.length; i++) {
                        _companys[i].oId = _companys[i].id;
                        _companys[i].id = i + 1;
                        _companys[i].edit = false;
                        vm.smartTableData.push(_companys[i]);
                    }
                    vm.smartTableData1 = vm.smartTableData;
                },
                function() {
                    console.error('Get companys failed!');
                }
            );
        }


    };

    UserCtrl.prototype.addCompany = function() {
        var vm = this;
        vm.$scope.inserted = {
            id: vm.smartTableData.length + 1,
            name: '',
            uniformNumber: '',
            email: '',
            fax: '',
            phone: '',
            address: '',
            edit: false,
            oId: '',
            status: 1
        };
        //vm.smartTableData.push(vm.$scope.inserted);
        vm.smartTableData.unshift(vm.$scope.inserted);
    };

    UserCtrl.prototype.saveCompany = function(item) {
        var vm = this;
        if (item.oId === '' || item.oId === undefined || item.oId === null) {
            item.id = '';
            vm.UserService.createCompany(item).then(
                function(data) {
                    alert('Save company success!');
                    item.edit = false;
                },
                function() {
                    console.error('Save company failed!');
                }
            );
        } else {
            vm.UserService.updateCompany(item, item.oId).then(
                function(data) {
                    alert('Save company success!');
                    item.edit = false;
                },
                function() {
                    console.error('Save company failed!');
                }
            );
        }
    }

    UserCtrl.prototype.delCustomer = function(item, index) {
        var vm = this;
        if (item.oId === '' || item.oId === undefined || item.oId === null) {
            return;
        }
        vm.UserService.delCustomer(item.oId).then(
            function(data) {
                vm.smartTableData.splice(index, 1);
                alert('Delete customer success!');
            },
            function() {
                console.error('Delete customer failed!');
            }
        );
    }

    UserCtrl.prototype.delCompany = function(item, index) {
        var vm = this;
        if (item.oId === '' || item.oId === undefined || item.oId === null) {
            return;
        }
        vm.UserService.delCompany(item.oId).then(
            function(data) {
                vm.smartTableData.splice(index, 1);
                alert('Delete company success!');
            },
            function() {
                console.error('Delete company failed!');
            }
        );
    }

    UserCtrl.prototype.createUser = function(type) {
        var vm = this;
        var user = vm.$scope.fmUser;
        vm.UserService.createUser(user, type).then(function(data) {
                alert('Create user success!');
            },
            function() {
                console.error('Create users failed!');
            }
        );
    }

    UserCtrl.prototype.editUser = function(userId) {
        var vm = this;
        vm.UserService.getUser(userId).then(
            function(data) {
                vm.$scope.fmUser = angular.copy(data.data);
            },
            function() {
                console.error('Update user failed!');
            }
        );
    }

    UserCtrl.prototype.saveUser = function() {
        var vm = this;
        var user = vm.$scope.fmUser;
        vm.UserService.updateUser(user, user.id).then(
            function(data) {
                alert('Update user success!');
            },
            function() {
                console.error('Update users failed!');
            }
        );
    }

    UserCtrl.prototype.getUers = function(role) {
        var vm = this;
        vm.UserService.getUers(role).then(function(data) {
                if (role === 'all-manager') {
                    vm.sales = data.data;
                } else if (role === 'worker') {
                    vm.workers = data.data;
                }
            },
            function() {
                console.error('Get users failed!');
            }
        );
    };

    UserCtrl.prototype.open = function(userId) {
        var vm = this;
        var css = 'app-modal-window';
        var page = 'app/kungfu/user/user-edit.html';
        var size = 'lg';
        if (userId !== undefined && userId !== '') {
            vm.editUser(userId);
        } else {
            vm.$scope.fmUser = {};
        }

        vm.$uibModal.open({
            //controller: 'UserCtrl as userCtrl',
            scope: vm.$scope,
            animation: true,
            templateUrl: page,
            size: size,
            //windowClass: css,
            resolve: {}
        }).closed.then(function() {
            //window.alert('Modal closed');
            //vm.getWorkerJobs(vm.jobDate); //Refresh data
        });
    };

    UserCtrl.prototype.open2 = function() {
        var vm = this;
        var css = 'app-modal-window';
        var page = 'app/kungfu/user/subItem-edit.html';
        var size = 'lg';
        vm.getItems();

        vm.$uibModal.open({
            controller: 'UserCtrl as userCtrl',
            scope: vm.$scope,
            animation: true,
            templateUrl: page,
            size: size,
            //windowClass: css,
            resolve: {}
        }).closed.then(function() {
            //window.alert('Modal closed');
            //vm.getWorkerJobs(vm.jobDate); //Refresh data
        });
    };

    UserCtrl.prototype.isNewUser = function() {
        var vm = this;
        if (vm.$scope.fmUser.id !== undefined && vm.$scope.fmUser.id !== '') {
            return false;
        }
        return true;
    };

    UserCtrl.prototype.getItems = function() {
        var vm = this;
        vm.ItemService.getItems().then(
            function(data) {
                var items = data.data;
                vm.$scope.items = items;
            },
            function() {
                console.error('Get items failed!');
            }
        );
    };

    UserCtrl.prototype.createSubItem = function() {
        var vm = this;
        var subItem = vm.$scope.fmSubItem;

        vm.ItemService.createSubItem(subItem).then(function(data) {
                alert('Create subItem success!');
            },
            function() {
                console.error('Create subItem failed!');
            }
        );
    }

    UserCtrl.prototype.getCustTypeSubItems = function() {
        var vm = this;
        try {
            vm.ItemService.getSubItems('custType').then(
                function(data) {
                    vm.$scope.custTypes = data.data;
                },
                function() {
                    console.error('Get sub items failed!');
                }
            );
        } catch (e) {
            console.log(e);
        }
    };

    UserCtrl.prototype.getCustTypeName = function(custTypeId) {
        var vm = this;
        var custTypeName = '';
        for (var i = 0; i < vm.$scope.custTypes.length; i++) {
            if (vm.$scope.custTypes[i].id === custTypeId) {
                custTypeName = vm.$scope.custTypes[i].name;
            }
        }
        return custTypeName;
    }

    UserCtrl.prototype.openImgPreView = function(img) {
        var vm = this;
        vm.$scope.previewImg = img;
    };

    UserCtrl.prototype.claimBonus = function(item) {
        var vm = this;
        vm.UserService.claimBonus(item).then(
            function(data) {
                alert('claim bonus success!');
            },
            function() {
                console.error('claim bonus failed!');
            }
        );
    }

})();

(function() {

    'use strict';

    angular.module('kungfu.job')
        .service('userService', UserService);

    UserService.$inject = ['$http'];

    function UserService($http) {

        this.createUser = function(user, type) {
            return $http.post('/api/user/' + type, user);
        };

        this.updateUser = function(user, userId) {
            return $http.put('/api/user/' + userId, user);
        };

        this.getUser = function(userId) {
            return $http.get('/api/user/' + userId);
        };

        this.getWorkers = function() {
            return $http.get('/api/worker');
        };

        this.getWorkersByStatus = function(status) {
            return $http.get('/api/worker/' + status);
        };

        this.getUers = function(role) {
            return $http.get('/api/users/' + role);
        };

        this.delUser = function(userId) {
            return $http.delete('/api/user/' + userId);
        };

        this.createCompany = function(item) {
            return $http.post('/api/company', item);
        };

        this.updateCompany = function(item, comapnyId) {
            return $http.put('/api/company/' + comapnyId, item);
        };

        this.getCompanys = function() {
            return $http.get('/api/company');
        };

        this.delCompany = function(comapnyId) {
            return $http.delete('/api/company/' + comapnyId);
        };

        this.createCustomer = function(item) {
            return $http.post('/api/customer', item);
        };

        this.updateCustomer = function(item, customerId) {
            return $http.put('/api/customer/' + customerId, item);
        };

        this.getCustomers = function() {
            return $http.get('/api/customer');
        };

        this.getBonusOfCases = function() {
            return $http.get('/api/bonus-case');
        };

        this.claimBonus = function(bonuses) {
            return $http.post('/api/claim-bonus', bonuses);
        };

        this.delCustomer = function(customerId) {
            return $http.delete('/api/customer/' + customerId);
        };

        this.getCustomersByCondition = function(params) {
            return $http.get('/api/customers', {
                params: params
            });
        };

        this.getCompanysByCondition = function(params) {
            return $http.get('/api/companys', {
                params: params
            });
        };
    }


})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {

    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      //***DIS AMCHART***
      // loadAmCharts : function(){
      //   var d = $q.defer();
      //   AmCharts.ready(function(){
      //     d.resolve();
      //   });
      //   return d.promise;
      // }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controller: 'AuthCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/layout/main.html","<div class=\"body-bg\"></div><main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }\"><ba-sidebar></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top></div></div><back-top></back-top></main><div id=\"preloader\" ng-show=\"!$pageFinishedLoading\"><div></div></div>");
$templateCache.put("app/kungfu/account/pay.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Rows\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-xs-3\"><p class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeStartDate(\'prev\')\"><i class=\"ion-arrow-return-left\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeStartDate(\'next\')\"><i class=\"ion-arrow-return-right\"></i></button></span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmReport.reportStartTime\" is-open=\"fmReport.calenderOpen1\" datepicker-options=\"dateOptions\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" style=\"border: 1px solid #233b80;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openCalender(1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-3\"><p class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeEndDate(\'prev\')\"><i class=\"ion-arrow-return-left\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeEndDate(\'next\')\"><i class=\"ion-arrow-return-right\"></i></button></span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmReport.reportEndTime\" is-open=\"fmReport.calenderOpen2\" datepicker-options=\"dateOptions\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" style=\"border: 1px solid #233b80;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openCalender(2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-2\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"付款單號\"></div><div class=\"col-xs-4\"><div class=\"row\"><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-click=\"reportCtrl.arrearQuery()\"><i class=\"ion-stats-bars\"></i>查詢</button></div><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-warning btn-with-icon\" ng-click=\"reportCtrl.changeEditMode(true, \'arrear\')\" ng-if=\"fmReport.editModel == false\"><i class=\"ion-wrench\"></i>編輯</button> <button type=\"button\" class=\"btn btn-success btn-with-icon\" ng-click=\"reportCtrl.changeEditMode(false, \'arrear\')\" ng-if=\"fmReport.editModel == true\"><i class=\"fa fa-eye\"></i>唯讀</button></div><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-danger btn-with-icon\" ng-click=\"reportCtrl.save(\'arrear\')\" ng-if=\"fmReport.editModel == true\"><i class=\"fa fa-save\"></i>儲存</button></div></div></div></div><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"smartTableData\" st-safe-src=\"smartTableData1\"><tr><td></td><td>付款單號</td><td>供應商</td><td>付款日期</td><td>金額</td><td>幣別</td><td>狀態</td><td>Actions</td></tr><tbody><tr class=\"editable-row\"><td>1</td><td>K17030288</td><td class=\"select-td\">錦誠電子有限公司</td><td class=\"select-td\">2017/01/01</td><td class=\"select-td\">53000</td><td class=\"select-td\">US</td><td class=\"select-td\">未付款</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"openPurchase()\">修改</button></td></tr><tr class=\"editable-row\"><td>2</td><td>K17030289</td><td class=\"select-td\">錦誠電子有限公司</td><td class=\"select-td\">2017/02/01</td><td class=\"select-td\">12000</td><td class=\"select-td\">US</td><td class=\"select-td\">已付款</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"openPurchase()\">修改</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/kungfu/account/receive.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Rows\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-xs-3\"><p class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeStartDate(\'prev\')\"><i class=\"ion-arrow-return-left\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeStartDate(\'next\')\"><i class=\"ion-arrow-return-right\"></i></button></span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmReport.reportStartTime\" is-open=\"fmReport.calenderOpen1\" datepicker-options=\"dateOptions\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" style=\"border: 1px solid #233b80;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openCalender(1)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-3\"><p class=\"input-group\"><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeEndDate(\'prev\')\"><i class=\"ion-arrow-return-left\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"reportCtrl.changeEndDate(\'next\')\"><i class=\"ion-arrow-return-right\"></i></button></span> <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmReport.reportEndTime\" is-open=\"fmReport.calenderOpen2\" datepicker-options=\"dateOptions\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" style=\"border: 1px solid #233b80;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"openCalender(2)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div><div class=\"col-xs-2\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: white; !important\" title=\"催款狀態\" ng-model=\"fmReport.qArrear\" ng-options=\"obj.id as obj.name for obj in arrearSubItems\"><option value=\"\">-- 收貨客戶 --</option></select></div><div class=\"col-xs-4\"><div class=\"row\"><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-click=\"reportCtrl.arrearQuery()\"><i class=\"ion-stats-bars\"></i>查詢</button></div><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-warning btn-with-icon\" ng-click=\"reportCtrl.changeEditMode(true, \'arrear\')\" ng-if=\"fmReport.editModel == false\"><i class=\"ion-wrench\"></i>編輯</button> <button type=\"button\" class=\"btn btn-success btn-with-icon\" ng-click=\"reportCtrl.changeEditMode(false, \'arrear\')\" ng-if=\"fmReport.editModel == true\"><i class=\"fa fa-eye\"></i>唯讀</button></div><div class=\"col-xs-3\"><button type=\"button\" class=\"btn btn-danger btn-with-icon\" ng-click=\"reportCtrl.save(\'arrear\')\" ng-if=\"fmReport.editModel == true\"><i class=\"fa fa-save\"></i>儲存</button></div></div></div></div><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"smartTableData\" st-safe-src=\"smartTableData1\"><tr><td></td><td>銷貨單號</td><td>客戶</td><td>日期</td><td>箱數</td><td>淨重</td><td>狀態</td><td>Actions</td></tr><tbody><tr class=\"editable-row\"><td>1</td><td>K17030288</td><td class=\"select-td\">錦誠電子有限公司</td><td class=\"select-td\">2017/01/01</td><td class=\"select-td\">53kg</td><td class=\"select-td\">596kg</td><td class=\"select-td\">未出貨</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"openPurchase()\">修改</button></td></tr><tr class=\"editable-row\"><td>2</td><td>K17030289</td><td class=\"select-td\">錦誠電子有限公司</td><td class=\"select-td\">2017/01/01</td><td class=\"select-td\">12</td><td class=\"select-td\">200kg</td><td class=\"select-td\">已出貨</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"openPurchase()\">修改</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/kungfu/account/sub-pay.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">進貨單</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"基本資料\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">供應商</label> <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i> <input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"V0388凱瑞國際有限公司\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputLastName\">聯絡人</label> <input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"陳先生\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">電話</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"0421231233\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">傳真</label> <input type=\"text\" class=\"form-control\" id=\"inputWebsite\" placeholder=\"0421231233\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">交貨地點</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"廣東省惠陽市陳江鎮水圍青春工業管理區\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">幣別</label><select class=\"form-control\" title=\"師傅\" ng-model=\"fmJob.copyJobWorker\" ng-options=\"obj.id as obj.name for obj in workers\" ng-required=\"true\"><option value=\"\">--請選擇--</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">備註</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">進貨日期</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmJob.copyJobWorkTime\" is-open=\"calOpened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calOpen()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"進貨單明細\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"smartTableData\" st-safe-src=\"smartTableData1\"><tr><td></td><td>產品代號</td><td>產品名稱</td><td>單位</td><td>單價</td><td>數量</td><td>金額</td><td>交貨日期</td><td>Actions</td></tr><tbody><tr class=\"editable-row\" ng-click=\"formCtrl.fff()\"><td>1</td><td>CR=473250P0A <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i></td><td class=\"select-td\">1AF823K2E07FH060B9R</td><td class=\"select-td\">PC</td><td class=\"select-td\">7.2</td><td class=\"select-td\">30</td><td class=\"select-td\">216</td><td class=\"select-td\">2017/03/29</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr><tr class=\"editable-row\" ng-click=\"formCtrl.getPurDetails()\"><td>2</td><td>CR=104250S02 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i></td><td class=\"select-td\">M43AA1455G250AL3102</td><td class=\"select-td\">PC</td><td class=\"select-td\">5</td><td class=\"select-td\">50</td><td class=\"select-td\">250</td><td class=\"select-td\">2017/03/29</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div><div class=\"widgets\" ng-show=\"purDetailShow\"><div ba-panel=\"\" ba-panel-title=\"產品代號/名稱: CR=104250S02 / 1AF823K2E07FH060B9R\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"purDetailTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"purDetailTableData\" st-safe-src=\"purDetailTableData\"><tr><td></td><td>來源訂單單號</td><td>訂購數量</td><td>已進貨數量</td><td>數量</td><td>Actions</td></tr><tbody><tr class=\"editable-row\"><td>1</td><td>訂單001 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openPurSelectReqest()\"></i></td><td>50</td><td>30</td><td>20</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr><tr class=\"editable-row\" ng-click=\"formCtrl.fff()\"><td>2</td><td>訂單002 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openPurSelectReqest()\"></i></td><td class=\"select-td\">50</td><td class=\"select-td\">30</td><td class=\"select-td\">0</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"purDetailTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"saveCopyJob()\">刪除</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"saveCopyJob()\">儲存</button></div></div></div></div>");
$templateCache.put("app/kungfu/account/sub-receive.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">進貨單</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"基本資料\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">供應商</label> <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i> <input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"V0388凱瑞國際有限公司\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputLastName\">聯絡人</label> <input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"陳先生\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">電話</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"0421231233\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">傳真</label> <input type=\"text\" class=\"form-control\" id=\"inputWebsite\" placeholder=\"0421231233\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">交貨地點</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"廣東省惠陽市陳江鎮水圍青春工業管理區\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">幣別</label><select class=\"form-control\" title=\"師傅\" ng-model=\"fmJob.copyJobWorker\" ng-options=\"obj.id as obj.name for obj in workers\" ng-required=\"true\"><option value=\"\">--請選擇--</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">備註</label> <input type=\"text\" class=\"form-control\" id=\"inputEmail\" placeholder=\"\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">進貨日期</label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmJob.copyJobWorkTime\" is-open=\"calOpened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calOpen()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div></div></div></div><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"進貨單明細\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"smartTableData\" st-safe-src=\"smartTableData1\"><tr><td></td><td>產品代號</td><td>產品名稱</td><td>單位</td><td>單價</td><td>數量</td><td>金額</td><td>交貨日期</td><td>Actions</td></tr><tbody><tr class=\"editable-row\" ng-click=\"formCtrl.fff()\"><td>1</td><td>CR=473250P0A <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i></td><td class=\"select-td\">1AF823K2E07FH060B9R</td><td class=\"select-td\">PC</td><td class=\"select-td\">7.2</td><td class=\"select-td\">30</td><td class=\"select-td\">216</td><td class=\"select-td\">2017/03/29</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr><tr class=\"editable-row\" ng-click=\"formCtrl.getPurDetails()\"><td>2</td><td>CR=104250S02 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openSelectReqest()\"></i></td><td class=\"select-td\">M43AA1455G250AL3102</td><td class=\"select-td\">PC</td><td class=\"select-td\">5</td><td class=\"select-td\">50</td><td class=\"select-td\">250</td><td class=\"select-td\">2017/03/29</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div><div class=\"widgets\" ng-show=\"purDetailShow\"><div ba-panel=\"\" ba-panel-title=\"產品代號/名稱: CR=104250S02 / 1AF823K2E07FH060B9R\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"formCtrl.addUser()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"purDetailTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"purDetailTableData\" st-safe-src=\"purDetailTableData\"><tr><td></td><td>來源訂單單號</td><td>訂購數量</td><td>已進貨數量</td><td>數量</td><td>Actions</td></tr><tbody><tr class=\"editable-row\"><td>1</td><td>訂單001 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openPurSelectReqest()\"></i></td><td>50</td><td>30</td><td>20</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr><tr class=\"editable-row\" ng-click=\"formCtrl.fff()\"><td>2</td><td>訂單002 <i class=\"fa fa-search-plus fa-5\" aria-hidden=\"true\" ng-click=\"openPurSelectReqest()\"></i></td><td class=\"select-td\">50</td><td class=\"select-td\">30</td><td class=\"select-td\">0</td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"rowform.$show()\">編輯</button></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"purDetailTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"saveCopyJob()\">刪除</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"saveCopyJob()\">儲存</button></div></div></div></div>");
$templateCache.put("app/kungfu/auth/auth.html","");
$templateCache.put("app/kungfu/chart/caseRegionPieChart.html","<div id=\"zoomAxisChart\" class=\"admin-chart\" ng-controller=\"PieChartCtrl\"></div>");
$templateCache.put("app/kungfu/chart/custCaseBarChart.html","<div id=\"barChart\" class=\"admin-chart\" ng-controller=\"ChartCtrl\"></div>");
$templateCache.put("app/kungfu/chart/custSaleGanttChart.html","<div class=\"row\"><div class=\"col-sm-1\"></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"inputWebsite\">設計師名稱</label> <input type=\"text\" class=\"form-control\" ng-model=\"qCustName\" maxlength=\"64\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"inputWebsite\">設計師Line</label> <input type=\"text\" class=\"form-control\" ng-model=\"qLine\" maxlength=\"64\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"inputWebsite\">設計師電話</label> <input type=\"text\" class=\"form-control\" ng-model=\"qPhone\" maxlength=\"64\"></div></div><div class=\"col-sm-1\"><div class=\"form-group\"><label style=\"color: white\">查詢</label> <button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-click=\"queryChart()\"><i class=\"ion-stats-bars\"></i>查詢</button></div></div></div><div id=\"granttChart\" ng-class=\"{\'granttChartH500\': isActive500, \'granttChartH4000\': isActive4000, \'granttChartH1000\': isActive1000, \'granttChartH2000\': isActive2000, \'granttChartH3000\': isActive3000, \'granttChartH250\': isActive250, \'granttChartH1500\': isActive1500}\"></div>");
$templateCache.put("app/kungfu/chart/designerBarChart.html","<div id=\"designAxisChart\" class=\"admin-chart\" ng-controller=\"DesignerBarChartCtrl\"></div>");
$templateCache.put("app/kungfu/cust/blurFeed.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\"><div class=\"feed-message\" ng-repeat=\"message in feed2\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{ ::( message.preview | appImage )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\">{{ ::message.author }} {{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span>{{::message.text}}</div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/kungfu/cust/bonusPieChart.html","<div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::chart.color }}\" data-percent=\"{{ ::chart.percent }}\"><span class=\"percent\">{{ ::chart.percent }}</span></div><div class=\"description\"><div class=\"description-stats\">{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.description2 }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"chart-icon i-{{ ::chart.icon }}\"></i></div></div></div></div>");
$templateCache.put("app/kungfu/cust/caseList.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\" ng-init=\"custCtrl.getCaseList()\"><div class=\"feed-message\" ng-repeat=\"message in caseList\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{ ::( message.preview | appImage )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\" style=\"color: #333399; font-size:18px;\">{{ ::message.date }}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span> <span style=\"color: #47476b; font-weight:bold; font-size:14px;\" ng-repeat=\"desc in message.text\">{{::desc}}<br></span></div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/kungfu/cust/cust.html","<div class=\"row\"><div class=\"col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"施工案件\" ba-panel-class=\"with-scroll feed-panel\"><case-list></case-list></div><div class=\"col-xlg-6 col-lg-6 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"最新優惠活動\" ba-panel-class=\"with-scroll feed-panel\"></div></div>");
$templateCache.put("app/kungfu/cust/promoteCust.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\" ng-init=\"custCtrl.getPromoteCust()\"><div class=\"feed-message\" ng-repeat=\"message in promoteCust\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{ ::( message.preview | appImage )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\" style=\"color: #FF0040; font-size:18px;\">{{ ::message.author }}</span> <span class=\"author\" style=\"font-size:18px;\">{{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.desc1}}</span><br><span style=\"color: #0080ff; font-weight: bolder; font-size:14px;\">{{::message.desc2}}</span></div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a> <a href=\"{{::message.link2}}\" target=\"_blank\" ng-if=\"message.preview2 !== false\"><img ng-src=\"{{ ::( message.preview2 | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/kungfu/cust/promoteDesigner.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\" ng-init=\"custCtrl.getPromoteD()\"><div class=\"feed-message\" ng-repeat=\"message in promoteD\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{ ::( message.preview | appImage )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\" style=\"color: #FF0040; font-size:18px;\">{{ ::message.author }}</span> <span class=\"author\" style=\"font-size:18px;\">{{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.desc1}}</span><br><span style=\"color: #0080ff; font-weight: bolder; font-size:14px;\">{{::message.desc2}}</span></div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a> <a href=\"{{::message.link2}}\" target=\"_blank\" ng-if=\"message.preview2 !== false\"><img ng-src=\"{{ ::( message.preview2 | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/kungfu/job/img-view.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: #233b80;\"><button type=\"button\" class=\"close\" aria-label=\"\" style=\"font-size: 16px;\" ng-click=\"$dismiss()\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">{{jobCtrl.imgModalName}}</h4></div><div class=\"modal-body\" ng-show=\"!isLine\"><img src=\"{{previewImg}}\" width=\"600px\"></div><div class=\"modal-body\" ng-show=\"isLine\"><textarea cols=\"80\" rows=\"20\" name=\"意見內容\">{{lineTxt}}</textarea></div></div>");
$templateCache.put("app/kungfu/job/job-copy.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">複製工單</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">業務</label><div class=\"col-sm-4\"><select class=\"form-control\" title=\"業務\" ng-model=\"fmJob.copyJobContact\" ng-options=\"obj.id as obj.name for obj in sales\" ng-required=\"true\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">施工日</label><div class=\"col-sm-6\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"fmJob.copyJobWorkTime\" is-open=\"calOpened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calOpen()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">師傅</label><div class=\"col-sm-4\"><select class=\"form-control\" title=\"師傅\" ng-model=\"fmJob.copyJobWorker\" ng-options=\"obj.id as obj.name for obj in workers\" ng-required=\"true\"><option value=\"\">--請選擇--</option></select></div></div></form></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveCopyJob()\">複製</button></div></div></div></div>");
$templateCache.put("app/kungfu/job/job-edit.html","<div class=\"modal-content\"><form ng-app=\"kungfu.job\" ng-controller=\"SubJobCtrl\" name=\"subJobForm\"><div class=\"modal-header\" style=\"padding: 5px; background-color: #233b80;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">{{fmJob.jobModalName}}</h4></div><div class=\"modal-body\" ng-init=\"\"><input type=\"hidden\" ng-model=\"fmJob.id\"><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\" ng-show=\"false\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">工單編號</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.name\" ng-readonly=\"true\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel-red\">接洽業務*</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #337ab7 !important\" title=\"業務\" ng-model=\"fmJob.contactId\" ng-required=\"true\" ng-options=\"obj.id as obj.name for obj in sales\" ng-change=\"changeBrand(fmJob.contactId)\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">Line</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-disabled=\"custExist\" ng-model=\"fmJob.code\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">工程款</label> <input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.casePiece\" ng-blur=\"checkCasePrePay(fmJob.casePiece)\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\" ng-show=\"isCasePrePay\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">代收</label> <input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.casePrePay\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">工資</label> <input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.workPiece\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">發票</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"發票\" ng-model=\"fmJob.invoice\" ng-options=\"obj.value as obj.name for obj in yesno\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">收款方式</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; !important\" ng-model=\"fmJob.payment\" ng-change=\"changePayment(fmJob.payment)\" ng-options=\"obj.id as obj.name for obj in paymentItems\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">已收</label> <input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.alreadyPay\"></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">業主</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.custName\" ng-disabled=\"custExist\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">電話</label><ui-select ng-model=\"fmJob.withSearchItem.selected\" class=\"btn-group bootstrap-select form-control\" ng-disabled=\"false\" append-to-body=\"false\" search-enabled=\"true\" on-select=\"selectCust($item)\" style=\"color: black\"><ui-select-match placeholder=\"搜尋電話\">{{$select.selected.account}}</ui-select-match><ui-select-choices repeat=\"withSearchItem in custs | filter: $select.search\" refresh=\"getCustPhone($select.search)\" refresh-delay=\"0\"><span ng-bind-html=\"withSearchItem.account\"></span></ui-select-choices></ui-select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">身份</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"身份\" ng-model=\"fmJob.custType\" ng-change=\"changeCustType(fmJob.custType)\" ng-options=\"obj.id as obj.name for obj in custTypeItems\" ng-disabled=\"custExist\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\" ng-show=\"isDesigner\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">設計公司</label> <input type=\"text\" class=\"form-control\" placeholder=\"\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.designCompany\" ng-disabled=\"custExist\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">居家</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"居家\" ng-model=\"fmJob.isHome\" ng-options=\"obj.value as obj.name for obj in yesno\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">店面</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"店面\" ng-model=\"fmJob.isStore\" ng-options=\"obj.value as obj.name for obj in yesno\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-{{msgsize}}\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">接洽者留言</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.custMessage\"></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">縣市</label><select class=\"form-control\" title=\"縣市\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #337ab7 !important\" ng-model=\"fmJob.country\" ng-options=\"key as value for (key, value) in countryList\" ng-change=\"getDistrict(fmJob.country)\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">區</label><select class=\"form-control\" title=\"區\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #337ab7 !important\" ng-model=\"fmJob.district\" ng-options=\"key as value for (key, value) in districtList\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">地址</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.address\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">電梯</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #337ab7 !important\" title=\"電梯\" ng-change=\"changeElevator(fmJob.elevator)\" ng-model=\"fmJob.elevator\" ng-options=\"obj for obj in isElevators\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\" ng-show=\"isTownHouse\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">樓層</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"透天\" ng-model=\"fmJob.townHouse\" ng-options=\"obj.value as obj.name for obj in townhouseFloor\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-{{shipsize}}\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">搬運備註</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.shipDesc\"></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><label class=\"editJobLabel\" for=\"inputLastName\">施工坪數</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><label class=\"editJobLabel\" for=\"inputLastName\">燈號</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><label class=\"editJobLabel\" for=\"inputLastName\">備貨型號</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><label class=\"editJobLabel\" for=\"inputLastName\">填縫類型</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><label class=\"editJobLabel\">牆面</label></div><div class=\"col-xs-4\"><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><label class=\"editJobLabel\">轉角</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><label class=\"editJobLabel\" for=\"inputLastName\">平磚</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><label class=\"editJobLabel\" for=\"inputLastName\">角磚</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><label class=\"editJobLabel\" for=\"inputLastName\">平自載</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><label class=\"editJobLabel\" for=\"inputLastName\">角自載</label></div></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><label class=\"editJobLabel\" for=\"inputLastName\">貨廠</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"></div></div><div class=\"row\" ng-repeat=\"input in workDetailSet\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.footage\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; background-color: {{input.lightBgColor}} !important\" title=\"施工燈號\" ng-model=\"input.light\" ng-options=\"obj.id as obj.name for obj in lightItems\" ng-change=\"consisWorkDetailLight(input.light)\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.stockType\" ng-change=\"checkSpecChar(this)\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; !important\" title=\"填縫類型\" ng-model=\"input.slit\" ng-options=\"obj.id as obj.name for obj in slitItems\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; !important\" title=\"牆面\" ng-model=\"input.wall\" ng-options=\"obj.id as obj.name for obj in wallItems\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"col-xs-4\"><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; !important\" title=\"轉角\" ng-model=\"input.corner\" ng-options=\"obj.id as obj.name for obj in cornerItems\"><option value=\"\">--請選擇--</option></select></div></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.flatBrickBoxes\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.angelBrickBoxes\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.shipFlatBoxes\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><input type=\"number\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"input.shipAngelBoxes\"></div></div></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; !important\" title=\"貨廠\" ng-model=\"input.factory\" ng-options=\"obj.id as obj.name for obj in factoryItems\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-1\"><div class=\"form-group\" style=\"margin-bottom: 0px;\"><i class=\"fa fa-plus-circle\" ng-click=\"addWorkDetailInput()\" style=\"font-size: 230%\"></i> <i class=\"fa fa-minus-circle\" ng-click=\"removeWorkDetailInput($index)\" style=\"font-size: 230%\"></i></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-8\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">施工注意及說明</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.workDesc\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">後勤支援留言</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.supportMessage\"></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">石材狀況</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.material\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">燈號</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black; background-color: {{fmJob.materialBGColor}} !important\" title=\"石材燈號\" ng-model=\"fmJob.materialLight\" ng-options=\"obj.id as obj.name for obj in stoneLightItems\" ng-change=\"confirmMaterialLight(fmJob.materialLight)\"><option value=\"\">--請選擇--</option></select><input type=\"hidden\" ng-model=\"fmJob.materialLight_bak\"></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">狀態</label><select class=\"form-control\" style=\"border: 1px solid #233b80; color: black !important\" title=\"狀態\" ng-model=\"fmJob.status\" ng-options=\"obj.value as obj.name for obj in jobStatus\"><option value=\"\">--請選擇--</option></select></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-4\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><label class=\"editJobLabel\">生管留言</label> <input type=\"text\" class=\"form-control\" style=\"border: 1px solid #233b80;\" ng-model=\"fmJob.managetMessage\"></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-3\"><label class=\"editJobLabel-red\" for=\"inputLastName\">施工日*</label></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-3\"><label class=\"editJobLabel-red\" for=\"inputLastName\">師傅*</label></div></div><div class=\"row\" ng-repeat=\"input in fmJob.workerJobSet\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-3\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" ng-model=\"input.workTime\" is-open=\"input.opened\" datepicker-options=\"dateOptions\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" style=\"border: 1px solid #233b80;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open1($index)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p></div></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\" ng-repeat=\"subInput in input.workers\"><select class=\"form-control\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #337ab7 !important\" title=\"師傅\" ng-model=\"subInput.id\" ng-options=\"obj.id as obj.name for obj in workers\"><option value=\"\">--請選擇--</option></select></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-3\"><div class=\"form-group\" style=\"margin-bottom: 10px;\"><button ng-click=\"addInput()\"><i class=\"ion-plus-round\"></i></button> <button ng-click=\"removeInput($index)\"><i class=\"ion-minus-round\"></i></button></div></div></div><div class=\"row\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2 imgDiv\" ng-repeat=\"jimg in fmJob.jobImages\"><a class=\"thumbnail\"><img src=\"{{jimg}}\" style=\"width: 90px; height: 90px !IMPORTANT\" ng-mouseenter=\"msin()\" ng-mousedown=\"msout()\" ng-click=\"openImgPreView(\'app/kungfu/job/img-view.html\', \'sm\', \'{{jimg}}\')\"></a> <img src=\"http://tdgj.mlr.gov.cn/images/%E5%8F%89%E5%8F%89.jpg\" ng-click=\"removeImg($index)\" class=\"delete\"></div><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2\"><input type=\"file\" ngf-select=\"uploadPic()\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"20MB\" ngf-min-height=\"100\" multiple=\"\"></div></div></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" ng-show=\"isNewJob(fmJob.id)\" class=\"btn btn-primary\" ng-click=\"delJob()\">刪除</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"ssave()\">儲存</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"downloadImg()\">下載圖片</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"copyJob()\">複製工單</button></div><div class=\"pull-left\"><a ng-click=\"sendLine(1)\"><img src=\"assets/img/linebutton_20x20_zh-hant.png\" width=\"40\" height=\"[按鍵的高度]\" alt=\"用LINE傳送\"><br><b>發給師傅</b></a></div><div class=\"pull-left\" style=\"padding-left: 30px;\"><a ng-click=\"sendLine(0)\"><img src=\"assets/img/linebutton_20x20_zh-hant.png\" width=\"40\" height=\"[按鍵的高度]\" alt=\"用LINE傳送\"><br><b>備貨用</b></a></div><div class=\"pull-left\" style=\"padding-left: 30px;\"><a ng-click=\"openLineView(\'app/kungfu/job/img-view.html\', \'sm\', 1)\"><img src=\"assets/img/linebutton_84x20_zh-hant.png\" width=\"100\" height=\"35\" alt=\"用LINE傳送\"><br><b>發給師傅(電腦版)</b></a></div><div class=\"pull-left\" style=\"padding-left: 30px;\"><a ng-click=\"openLineView(\'app/kungfu/job/img-view.html\', \'sm\', 0)\"><img src=\"assets/img/linebutton_84x20_zh-hant.png\" width=\"100\" height=\"35\" alt=\"用LINE傳送\"><br><b>備貨用(電腦版)</b></a></div></div></div></form></div>");
$templateCache.put("app/kungfu/job/job.html","<div ng-init=\"jobCtrl.pullJobStatus()\"><div ba-panel-title=\"Bordered Table\" ba-panel-class=\"with-scroll table-panel\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"jobCtrl.getPrevWorkerJobs()\"><i class=\"ion-reply\"></i>前一頁</button> <button type=\"button\" class=\"btn btn-primary btn-with-icon\" ng-click=\"jobCtrl.getNextWorkerJobs()\"><i class=\"ion-forward\"></i>後一頁</button></div><div class=\"pull-left\" style=\"padding-right: 5px;\"><select class=\"form-control btn-primary\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #088679\" ng-model=\"jobCtrl.queryYear\" ng-options=\"y for y in jobCtrl.years\">><option value=\"\">年度</option></select></div><div class=\"pull-left\" style=\"padding-bottom: 2px;\"><select class=\"form-control btn-primary\" style=\"border: 1px solid #233b80; color: #f5f5f5; background-color: #088679\" ng-model=\"jobCtrl.queryMonth\" ng-change=\"jobCtrl.getWorkerJobsByYM()\" ng-options=\"m for m in jobCtrl.months\"><option value=\"\">月份</option></select></div><table class=\"table table-bordered table-condensed\"><thead><tr><th style=\"color: white; background-color: #1c2b36; border: 5px solid #f5f5f5; !important\" class=\"browser-icons\"></th><th style=\"color: white; border: 5px solid #f5f5f5; text-align: center; height: 35px; !important\" class=\"col-lg-1 row-xs-1\" ng-style=\"{\'background-color\': jobCtrl.isWeekend(wd, \'header\')}\" ng-repeat=\"wd in jobCtrl.workDates | orderBy: \'-wd\'\">{{wd}}</th></tr></thead><tbody ng-repeat=\"(worker, jobs) in jobCtrl.workJobs\" style=\"background-color: #d9edf7; border: 5px solid #f5f5f5; !important\" make-me-green=\"\"><tr><td class=\"col-xs-1\" style=\"color: white; font-size: medium; overflow:hidden; width: 85px; white-space:nowrap;\" ng-style=\"{\'background-color\': jobCtrl.getWorkerColor(worker)}\">{{worker}}</td><td ng-repeat=\"(date, jb) in jobs\" style=\"border: 5px solid #f5f5f5; !important\" ng-style=\"{\'background-color\': jobCtrl.isWeekend(date, \'body\')}\" ng-right-click=\"jobCtrl.leaveConfirm($event, worker, date)\" ng-dblclick=\"open(date, \'\', \'app/kungfu/job/job-edit.html\', \'lg\', \'\', \'\', \'\', \'\')\"><div ng-repeat=\"sjb in jb\" class=\"alert\" style=\"margin-bottom:2px; margin-top:2px; letter-spacing: 0.5px; line-height: 15px; padding: 0px; overflow:hidden; height: 65px; width: 95px; white-space:nowrap; color:black;\" ng-click=\"open(date, sjb.jobId, \'app/kungfu/job/job-edit.html\', \'lg\', sjb.type, $event, worker, sjb.subJobId)\" ng-style=\"{\'background-color\': jobCtrl.getSubJobBGColor(sjb.type), \'border\': jobCtrl.getBorder(this)}\" id=\"{{sjb.subJobId}}\"><center><img src=\"/assets/img/person.svg\" ng-show=\"jobCtrl.isLeaveDay(sjb.type)\"></center><span ng-hide=\"jobCtrl.isLeaveDay(sjb.type)\"><b style=\"background-color: {{sjb.salesColor}};\">{{sjb.name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b><br><b style=\"background-color: {{sjb.stockColor}};\">{{sjb.address}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b><br><b style=\"background-color: {{sjb.stockColor}};\">{{sjb.stock}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b><br><b style=\"background-color: {{sjb.materialColor}};\">{{sjb.mLight}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b></span></div></td></tr></tbody></table></div></div></div><div style=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"myDialog\"><div ui-view=\"host-edit\"></div></div></div>");
$templateCache.put("app/kungfu/user/bonus.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"案件累計獎金\" ba-panel-class=\"with-scroll\"><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"userCtrl.smartTableDataPageSize\" ng-options=\"i for i in [5,10,20,50,100]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"userCtrl.smartTableData\" st-safe-src=\"userCtrl.smartTableData1\"><tr><td></td><td>客戶名稱</td><td>LINE</td><td>累計案件</td><td>Actions</td></tr><tbody><tr ng-repeat=\"item in userCtrl.smartTableData\" class=\"editable-row\"><td>{{item.id}}</td><td><span>{{item.custName}}</span></td><td><span>{{item.line}}</span></td><td><span ng-repeat=\"case in item.bonus\">({{$index+1}}) {{case.date.substring(0, 10)}} {{case.address}}<br></span></td><td><button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"userCtrl.claimBonus(item)\">確認發放</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"userCtrl.smartTableDataPageSize\" st-displayed-pages=\"20\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/kungfu/user/caseList.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\" ng-init=\"custCtrl.getCaseList()\"><div class=\"feed-message\" ng-repeat=\"message in caseList\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{ ::( message.preview | appImage )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\">{{ ::message.author }} {{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span> <span ng-repeat=\"xxx in message.text\">{{::xxx}}<br></span></div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/kungfu/user/company.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"公司資料清冊\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"inputFirstName\">公司名稱</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCompany.qName\" maxlength=\"128\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"inputWebsite\">電話</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCompany.qPhone\" maxlength=\"64\"></div></div><div class=\"col-sm-1\"><div class=\"form-group\"><label style=\"color: white\">公司查詢</label> <button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-click=\"userCtrl.getTableCompanys(true)\"><i class=\"ion-stats-bars\"></i>查詢</button></div></div><div class=\"col-sm-3\"></div></div><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"userCtrl.addCompany()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"userCtrl.smartTableDataPageSize\" ng-options=\"i for i in [5,10,20,50,100]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"userCtrl.smartTableData\" st-safe-src=\"userCtrl.smartTableData1\"><tr><td></td><td>公司名稱</td><td>地址</td><td>統編</td><td>電話</td><td>傳真</td><td>Actions</td></tr><tbody><tr ng-repeat=\"item in userCtrl.smartTableData\" class=\"editable-row\"><td>{{item.id}}</td><td><span ng-if=\"item.edit === false\">{{item.name}}</span> <input class=\"form-control\" type=\"input\" ng-model=\"item.name\" ng-if=\"item.edit === true\"></td><td><span ng-if=\"item.edit === false\">{{item.address}}</span> <input class=\"form-control\" type=\"input\" ng-model=\"item.address\" ng-if=\"item.edit === true\"></td><td><span ng-if=\"item.edit === false\">{{item.uniformNumber}}</span> <input class=\"form-control\" type=\"input\" ng-model=\"item.uniformNumber\" ng-if=\"item.edit === true\"></td><td><span ng-if=\"item.edit === false\">{{item.phone}}</span> <input class=\"form-control\" type=\"input\" ng-model=\"item.phone\" ng-if=\"item.edit === true\"></td><td><span ng-if=\"item.edit === false\">{{item.fax}}</span> <input class=\"form-control\" type=\"input\" ng-model=\"item.fax\" ng-if=\"item.edit === true\"></td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"userCtrl.editCompany(item)\" ng-if=\"item.edit === false\">編輯</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"userCtrl.delCompany(item, $index)\" ng-if=\"item.edit === false\">刪除</button> <button class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"userCtrl.saveCompany(item)\" ng-if=\"item.edit === true\">儲存</button> <button class=\"btn btn-default editable-table-button btn-xs\" ng-click=\"userCtrl.cancel(item)\" ng-if=\"item.edit === true\">取消</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"userCtrl.smartTableDataPageSize\" st-displayed-pages=\"20\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/kungfu/user/cust.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"客戶資料清冊\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"\">姓名</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.qName\" maxlength=\"128\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"\">電話</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.qPhone\" maxlength=\"64\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"\">LINE</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.qLine\" maxlength=\"64\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label for=\"\">公司</label><select class=\"form-control\" title=\"公司\" ng-model=\"fmCust.qCompany\" ng-options=\"obj.id as obj.name for obj in userCtrl.companys\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"col-sm-1\"><div class=\"form-group\"><label style=\"color: white\">客戶查詢</label> <button type=\"button\" class=\"btn btn-default btn-with-icon\" ng-click=\"userCtrl.getTableCustomers(true)\"><i class=\"ion-stats-bars\"></i>查詢</button></div></div><div class=\"col-sm-1\"></div></div><div class=\"add-row-editable-table\"><div class=\"row\"><div class=\"col-md-11\"><button class=\"btn btn-info\" ng-click=\"openCustomer()\">新增</button></div><div class=\"col-md-1\"><select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"userCtrl.smartTableDataPageSize\" ng-options=\"i for i in [5,10,20,50,100]\"></select></div></div></div><table class=\"table table-bordered table-hover table-condensed\" st-table=\"userCtrl.smartTableData\" st-safe-src=\"userCtrl.smartTableData1\"><tr><td></td><td>LINE</td><td>客戶名稱</td><td>電話</td><td>公司</td><td>身份</td><td>地區</td><td>Actions</td></tr><tbody><tr ng-repeat=\"item in userCtrl.smartTableData\" class=\"editable-row\"><td>{{item.id}}</td><td>{{item.line}}</td><td><span>{{item.name}}</span></td><td><span>{{item.phone}}</span></td><td><span>{{item.company.name}}</span></td><td><span>{{item.custTypeName}}</span></td><td><span>{{item.region}}</span></td><td><button class=\"btn btn-info editable-table-button btn-xs\" ng-click=\"openCustomer(item)\">編輯</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"userCtrl.delCustomer(item, $index)\">刪除</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"userCtrl.smartTableDataPageSize\" st-displayed-pages=\"20\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/kungfu/user/custDashborad.html","<div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::chart.color }}\" data-percent=\"60\"><span class=\"percent\"></span></div><div class=\"description\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"chart-icon i-{{ ::chart.icon }}\"></i></div></div></div></div>");
$templateCache.put("app/kungfu/user/sale.html","<div class=\"row\"><div class=\"col-lg-6 col-md-6\" ba-panel=\"\" ba-panel-title=\"案件統計表\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/kungfu/chart/caseRegionPieChart.html\'\"></div></div><div class=\"col-lg-6 col-md-6\" ba-panel=\"\" ba-panel-title=\"設計師人數統計表\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/kungfu/chart/designerBarChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-title=\"設計師案件統計\" ba-panel-class=\"with-scroll feed-panel\"><cust-sale-gantt-chart></cust-sale-gantt-chart></div></div>");
$templateCache.put("app/kungfu/user/sub-cust.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">客戶維護</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"客戶資料\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">姓名</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.name\" maxlength=\"128\" ng-required=\"true\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">Line</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.line\" maxlength=\"64\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"\">身份</label><select class=\"form-control\" title=\"身份\" ng-model=\"fmCust.custType\" ng-change=\"userCtrl.changeCustType()\" ng-options=\"obj.id as obj.name for obj in custTypes\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"\">公司</label><ui-select ng-model=\"userCtrl.withSearchItem.selected\" class=\"btn-group bootstrap-select form-control\" ng-disabled=\"false\" append-to-body=\"false\" search-enabled=\"true\"><ui-select-match placeholder=\"Select With Search\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"withSearchItem in userCtrl.companys | filter: $select.search\"><span ng-bind-html=\"withSearchItem.name\"></span></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputFirstName\">電話</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.phone\" ng-readonly=\"\" maxlength=\"64\" ng-required=\"true\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputWebsite\">電話2</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.phone2\" maxlength=\"64\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputWebsite\">傳真</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.fax\" maxlength=\"64\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputWebsite\">出處</label><select class=\"form-control\" title=\"出處\" ng-model=\"fmCust.origin\" ng-options=\"obj.value as obj.name for obj in originlList\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputWebsite\">地區</label><select class=\"form-control\" title=\"地區\" ng-model=\"fmCust.region\" ng-options=\"value as value for (key, value) in countryList\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label for=\"inputWebsite\">Email</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.email\" maxlength=\"128\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"inputFirstName\">備註</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.description\" maxlength=\"500\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"inputFirstName\">備註2</label> <input type=\"text\" class=\"form-control\" ng-model=\"fmCust.description2\" maxlength=\"500\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label for=\"inputFirstName\">圖檔上傳</label> <input type=\"file\" ngf-select=\"uploadPic()\" ng-model=\"fmCust.file\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-max-size=\"20MB\" ngf-min-height=\"100\" multiple=\"\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div style=\"padding-right: 5px; padding-left: 5px;\" class=\"col-xs-2 imgDiv\" ng-repeat=\"jimg in fmCust.jobImages\"><a class=\"thumbnail\"><img src=\"{{jimg}}\" style=\"width: 90px; height: 90px !IMPORTANT\" ng-mouseenter=\"msin()\" ng-mousedown=\"msout()\" ng-click=\"userCtrl.openImgPreView(\'{{jimg}}\')\"></a> <img src=\"http://tdgj.mlr.gov.cn/images/%E5%8F%89%E5%8F%89.jpg\" ng-click=\"removeImg($index)\" class=\"delete\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><img src=\"{{previewImg}}\" width=\"600px\"></div></div></div></div></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"userCtrl.saveCustomer(fmCust.oId)\">儲存</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cancelPopWin()\">取消</button></div></div></div></div>");
$templateCache.put("app/kungfu/user/subItem-edit.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">sub-item</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">項目</label><div class=\"col-sm-4\"><select class=\"form-control\" title=\"項目\" ng-model=\"fmSubItem.item.id\" ng-options=\"obj.id as obj.name for obj in items\"><option value=\"\">--請選擇--</option></select></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">名稱</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmSubItem.name\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">代碼</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmSubItem.code\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">顏色</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmSubItem.color\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">順序</label><div class=\"col-sm-2\"><input type=\"number\" class=\"form-control\" ng-model=\"fmSubItem.showOrder\"></div></div></form></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"userCtrl.createSubItem()\">Save</button></div></div></div></div>");
$templateCache.put("app/kungfu/user/user-edit.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"padding: 5px; background-color: gray;\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"\" style=\"font-size: 16px; margin-bottom: 1px;\" =\"close\"=\"\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" style=\"color: #f5f5f5\">xxxxxxx{{fmUser}}</h4></div><div class=\"modal-body\" ng-init=\"subJobCtrl.initData()\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">姓名</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmUser.name\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">帳號</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmUser.account\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" ng-model=\"fmUser.password\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" ng-model=\"fmUser.email\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">電話</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"fmUser.phone1\"></div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">順序</label><div class=\"col-sm-2\"><input type=\"number\" class=\"form-control\" ng-model=\"fmUser.showOrder\"></div></div><div class=\"form-group\"><label for=\"\" class=\"col-sm-2 control-label\">啟用</label><div class=\"col-sm-2\"><input type=\"radio\" ng-model=\"fmUser.status\" value=\"1\">是 <input type=\"radio\" ng-model=\"fmUser.status\" value=\"0\">否</div></div><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">區域</label><div class=\"col-sm-2\"><select class=\"form-control\" title=\"區域\" ng-model=\"fmUser.workGroup\" ng-options=\"obj.value as obj.name for obj in workGroups\"><option value=\"\">--請選擇--</option></select></div></div></form></div><div class=\"modal-footer\"><div class=\"horizontal-scroll center-block\"><div class=\"pull-right\"><button type=\"button\" ng-show=\"userCtrl.xxx()\" class=\"btn btn-primary\" ng-click=\"userCtrl.createUser(\'worker\')\">新增</button> <button type=\"button\" ng-show=\"userCtrl.xxx()\" class=\"btn btn-primary\" ng-click=\"userCtrl.createUser(\'worker\')\">更新</button></div></div></div></div>");
$templateCache.put("app/kungfu/user/user.html","<div class=\"widgets\"><div ba-panel=\"\" ba-panel-title=\"Hover Rows\" ba-panel-class=\"with-scroll\"><div class=\"align-right\"><button type=\"button\" ng-show=\"showXXX\" class=\"btn btn-success btn-icon\" ng-click=\"userCtrl.open()\"><i class=\"ion-android-checkmark-circle\"></i></button> <button type=\"button\" ng-show=\"showXXX\" class=\"btn btn-info btn-icon\" ng-click=\"userCtrl.open2()\"><i class=\"ion-android-checkmark-circle\"></i></button></div><div class=\"horizontal-scroll\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"browser-icons\"></th><th>姓名</th><th class=\"align-right\">帳號</th><th class=\"table-arr\"></th><th class=\"align-right\">排序</th><th class=\"table-arr\"></th><th class=\"align-right\">%</th><th class=\"table-arr\"></th></tr></thead><tbody><tr ng-repeat=\"item in userCtrl.workers\" class=\"no-top-border\" ng-dblclick=\"userCtrl.open(item.id)\"><td></td><td ng-class=\"nowrap\">{{item.name}}</td><td class=\"align-right\">{{item.account}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }\"></i></td><td class=\"align-right\">{{item.showOrder}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }\"></i></td><td class=\"align-right\"></td><td class=\"table-arr\"></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-disabled=\"$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span> previous</button></li><li class=\"next\"><button ng-disabled=\"$baWizardController.isLastTab()\" ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">next <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb\"><li><a href=\"#/job/job/list\">主頁</a></li><li>{{ activePageTitle }}</li></ul></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix\"><b style=\"color: #B8B8B8\"><span style=\"color: #D6FF00\">陳</span>師傅</b></a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"user-profile clearfix\" style=\"margin-top: 25px;\"><a style=\"float: right; color: white\" href=\"http://www.chenculturestone.com.tw\" target=\"_self\"><i class=\"fa fa-home\"></i> 回官網</a> <a style=\"float: right; margin-right: 10px; color: white\" \"=\"\" ng-click=\"logout()\"><i class=\"fa fa-power-off\"></i> 登出</a></div></div>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");}]);